// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T16:13:25.203Z
// Property: The Heights at Happy Valley (ID: 6767906449167749)
// Collections: 30 amenities, 14 floorplans (live), 69 photos, 76 POIs, 3 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162471",
  "multihub_property_id": "6767906449167749",
  "property_external_id": "snl3ln7",
  "property_zillow_url": "https://www.zillow.com/apartments/happy-valley-or/the-heights-at-happy-valley/CqYTcJ/",
  "property_apartments_url": "https://www.apartments.com/the-heights-at-happy-valley-happy-valley-or/snl3ln7/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Heights+at+Happy+Valley/@45.4140988,-122.4879699,803m/data=!3m2!1e3!4b1!4m6!3m5!1s0x54959fd918b6fdfb:0xc38b3fd86c14bd83!8m2!3d45.4140988!4d-122.4879699!16s%2Fg%2F11yz8l_d1r?entry=ttu&g_ep=EgoyMDI2MDgzMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "Resman",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-heights-at-happy-valley",
  "property_name": "The Heights at Happy Valley",
  "property_website_url": "https://www.theheightshappyvalley.com/",
  "property_domain": "https://www.theheightshappyvalley.com/",
  "property_address": "17134 SE Rock Creek Blvd",
  "property_full_address": "17134 SE Rock Creek Blvd, Happy Valley, OR 97015",
  "property_address_1": "17134 SE Rock Creek Blvd",
  "property_address_2": null,
  "property_address_city": "Happy Valley",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97015",
  "property_address_country": "US",
  "property_address_county": "Clackamas County",
  "property_neighborhood_address": "Rock Creek",
  "property_address_latitude": "45.4140988",
  "property_address_longitude": "-122.4879699",
  "property_email": null,
  "property_phone": "(971) 233-4611",
  "property_call_tracking_phone": "5412093594",
  "property_company_name": "Cobalt",
  "property_company_url": "https://cobaltbuilt.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Brand-new Rock Creek apartments surrounded by PNW green space.</strong> Explore open one-, two-, and three-bedroom layouts with quartz finishes, in-home laundry, private outdoor space, and flexible live/work options—then compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_long_description": "<p><strong>Brand-new apartments in Rock Creek, surrounded by PNW green space.</strong> At The Heights at Happy Valley, you come home to open one-, two-, and three-bedroom layouts—including flexible live/work options—with quartz countertops, stainless-steel appliances, in-home laundry, spacious closets, and private outdoor space.</p><p>Days flow easily here: start in the 24/7 fitness center and sauna, spread out in the work-from-anywhere space, unwind at the pool and spa, or head outside for pickleball, disc golf, BBQs, the bark park, and connected bike and walking trails. Explore the full <a href=\"/amenities\">amenity collection</a> or compare <a href=\"/floor-plans\">available floor plans</a> when you’re ready.</p><p>Set near Happy Valley Town Center, Fred Meyer, New Seasons Market, Valley Public House, and the food carts at Happy Valley Station, this address keeps everyday errands and local flavor close. Scouters Mountain, Mount Talbert, Hidden Falls Nature Park, and Clackamas Town Center—plus Highway 224 and the MAX Green Line connection nearby—put more of Happy Valley and greater Portland within easy reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05871-7c3b-72dc-a0d8-b84326889597.webp",
  "property_featured_image_media": {
    "alt_text": "Gym room with large exercise balls and view of the pool area.",
    "public_id": "01a05871-7c3b-72dc-a0d8-b84326889597",
    "storage_key": "property/6767906449167749/01a05871-7c3b-72dc-a0d8-b84326889597.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167749/01a0dad4-397b-7570-b69b-174e841b0493.mp4",
  "property_featured_video_media": {
    "public_id": "01a0dad4-397b-7570-b69b-174e841b0493",
    "storage_key": "property/6767906449167749/01a0dad4-397b-7570-b69b-174e841b0493.mp4",
    "thumbnail_key": "property/6767906449167749/01a0dad4-397b-7570-b69b-174e841b0493_thumb.webp",
    "size_bytes": 18178028,
    "classification": "Community",
    "title": "Explore the Serene Ambiance of Our Apartment Community",
    "description": "Discover the beautifully designed exteriors and welcoming atmosphere of our apartment community. Enjoy a peaceful setting surrounded by nature and modern amenities."
  },
  "property_total_units": "174",
  "property_year_built": "2026",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "50.57471264367817",
  "property_admin_fee": "0",
  "property_application_fee": "45",
  "property_fees_deposit_info": "500-800",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "500",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of two pets per home.",
  "property_pet_policy_description": "Cats and dogs allowed. Maximum of two pets per home. Pet deposit: $300 per pet. Monthly pet rent: $35 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://myrentalapplication.com/index/theheightsathappyvalley",
  "property_resident_portal_url": "https://neighborlyventures.myresman.com/Portal/Access/SignIn/HHV",
  "property_apply_now_url": "https://myrentalapplication.com/index/theheightsathappyvalley",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-cc14-757b-935d-16f83b2ff90d.webp",
  "property_primary_logo_media": {
    "alt_text": "The Heights at Happy Valley logo with a mountain graphic.",
    "public_id": "01a05870-cc14-757b-935d-16f83b2ff90d",
    "storage_key": "property/6767906449167749/01a05870-cc14-757b-935d-16f83b2ff90d.webp",
    "width": 2000,
    "height": 2000
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08310-04a9-725c-9797-9675c49a0e38.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Heights logo with a mountain graphic",
    "public_id": "01a08310-04a9-725c-9797-9675c49a0e38",
    "storage_key": "property/6767906449167749/01a08310-04a9-725c-9797-9675c49a0e38.webp",
    "width": 2286,
    "height": 1148
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05871-9d7c-746b-8636-cd4abe749f67.webp",
  "property_icon_media": {
    "alt_text": "Geometric mountain range logo",
    "public_id": "01a05871-9d7c-746b-8636-cd4abe749f67",
    "storage_key": "property/6767906449167749/01a05871-9d7c-746b-8636-cd4abe749f67.webp",
    "width": 1259,
    "height": 646
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-ca99-7603-8e95-28b4ec0bf0bd.webp",
  "property_fav_icon_media": {
    "alt_text": "Geometric mountain range logo",
    "public_id": "01a05870-ca99-7603-8e95-28b4ec0bf0bd",
    "storage_key": "property/6767906449167749/01a05870-ca99-7603-8e95-28b4ec0bf0bd.webp",
    "width": 2625,
    "height": 1591
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05e30-7e08-72bb-9801-1c528f0ede85.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a05e30-7e08-72bb-9801-1c528f0ede85",
    "storage_key": "property/6767906449167749/01a05e30-7e08-72bb-9801-1c528f0ede85.webp",
    "width": 1259,
    "height": 646
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05871-9d7c-746b-8636-cd4abe749f67.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Geometric mountain range logo",
    "public_id": "01a05871-9d7c-746b-8636-cd4abe749f67",
    "storage_key": "property/6767906449167749/01a05871-9d7c-746b-8636-cd4abe749f67.webp",
    "width": 1259,
    "height": 646
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162471/01a0c9e6-767d-7068-bfd2-02c98e18a059.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162471/01a0ca52-f30f-7748-a6da-18b1abb45f57.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#dcd2c3",
  "property_secondary_color": "#2f4d58",
  "property_font_color": null,
  "property_color_4": "#505648",
  "property_color_3": "#b09879",
  "property_color_5": "#e6e8ea",
  "property_color_6": "#000000",
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "767 - 1,299 sq ft",
  "property_sqft_min": "767",
  "property_sqft_max": "1,299",
  "property_price_range": "$1865 - $2790",
  "property_price_min": "1865",
  "property_price_max": "2790",
  "property_available_units": 86,
  "property_facebook_url": "https://www.facebook.com/TheHeightsHappyValley",
  "property_instagram_url": "https://www.instagram.com/theheightshappyvalley",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ-_22GNmflVQRg70UbNg_i8M",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Heights at Happy Valley",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today!",
  "property_home_amenities_blurb": "<p><strong>More than a checklist of amenities.</strong> The Heights at Happy Valley brings daily convenience and downtime together with a work-from-anywhere space, 24/7 fitness center, sauna, pool, spa, and BBQ areas. Outside, discover pickleball, disc golf baskets, trail access, a bark park, and a resident you-pick herb garden—plus apartment finishes like quartz countertops, stainless-steel appliances, in-home laundry, air conditioning, generous storage, and select private outdoor spaces.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to flex.</strong> Choose from one-, two-, and three-bedroom apartments, plus select live/work layouts designed with extra separation for projects, tasks, and downtime.</p><p>Open living spaces, quartz-topped kitchens, soft-close cabinetry, stainless-steel appliances, in-home laundry, air conditioning, and private patios or decks with storage bring everyday function into focus.</p>",
  "property_home_gallery_blurb": "<p><strong>See The Heights at Happy Valley in focus.</strong> Browse bright interiors with quartz-style kitchen surfaces, wood cabinetry, stainless-steel appliances, breakfast-bar seating, private patios or decks, modern baths, organized closets, and in-home laundry. Then preview the pool and spa, clubhouse lounge, fitness center, sauna, and outdoor gathering areas that shape the relaxed Rock Creek setting.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Rock Creek puts more on the map.</strong> From tree-lined streets and scenic green pockets to Sunnyside Road’s coffee, groceries, taprooms, and tasting rooms, The Heights at Happy Valley keeps daily plans close and weekend routes open. Grab wood-fired pizza at Stickmen Brewing, explore Happy Valley Park or Mount Scott Creek Trail, and connect farther out via Clackamas Town Center Transit Center for MAX Green Line access to Portland, Clackamas, Gresham, and beyond.</p>",
  "property_home_reviews_blurb": "<p><strong>Attentive service stands out in resident reviews.</strong> Feedback for The Heights at Happy Valley often mentions an easy move-in, helpful leasing guidance, and a team that takes time with questions. Residents also call out Hannah by name for going “above and beyond.”</p><p>From “lovely” tours to clear amenity details and prompt, polite maintenance follow-through, the reviews point to care that continues after move-in. Read more to see the full resident perspective.</p>",
  "property_neighborhood_blurb": "<p><strong>Rock Creek keeps your map interesting.</strong> From The Heights at Happy Valley, you can move from tree-lined streets and the Rock Creek corridor to coffee, groceries, tasting rooms, and taprooms clustered around Sunnyside Road. Try wood-fired pizza at Stickmen Brewing, stop by Willamette Valley Vineyards’ Happy Valley tasting room, or follow the map toward Happy Valley Park, Mount Scott Creek Trail, and other green pockets that make the east side feel open and scenic.</p><p>When you want a wider radius, Clackamas Town Center Transit Center connects to the MAX Green Line and regional buses, while everyday routes keep Portland, Clackamas, Gresham, and Mount Hood-area escapes within reach. Explore the neighborhood, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this Rock Creek address fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, right where your day happens.</strong> At The Heights at Happy Valley, convenience and downtime share the same address. Move from a focused session in the work-from-anywhere space to a 24/7 workout and sauna reset, then settle into pool-and-spa time or an evening around the BBQs. Outdoor details go beyond the expected, with pickleball, disc golf baskets, trail access, a bark park, and even a resident you-pick herb garden adding fresh ways to use your community.</p><p>Inside your apartment, polished finishes keep the experience just as effortless: quartz countertops, stainless-steel appliances, in-home laundry, air conditioning, generous storage, and private outdoor space in select layouts. Browse the <a href=\"/gallery\">photo gallery</a> for a closer look, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the amenities fit your routine.</p>",
  "property_applynow_blurb": "<p><strong>Start your application for The Heights at Happy Valley.</strong><br>Brand-new one-, two-, and three-bedroom apartments offer open layouts, quartz countertops, stainless-steel appliances, in-home laundry, spacious closets, and private outdoor space—all surrounded by PNW green space. When you’re ready, apply online and take the next step toward home.</p>",
  "property_contactus_blurb": "<p><strong>Questions? Need directions?</strong> Connect with the leasing team at The Heights at Happy Valley for help exploring brand-new one-, two-, and three-bedroom apartments in Rock Creek, from flexible live/work layouts to PNW green space and everyday access around Happy Valley.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Heights at Happy Valley?</strong> Start here for quick answers about brand-new one-, two-, and three-bedroom apartments, flexible live/work layouts, community features, leasing details, and everyday living in Rock Creek. If you need anything else, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Compare layouts built for real flexibility.</strong> At The Heights at Happy Valley, your floor plan choices go beyond one-, two-, and three-bedroom apartments, with select live/work designs that give you dedicated room to separate tasks, projects, and downtime without leaving home.</p><p>Inside, open living areas connect to polished kitchens with quartz countertops, soft-close cabinetry, undermount lighting, and energy-efficient stainless-steel appliances. In-home laundry, air conditioning, hardwood-style plank flooring, and organized closet systems add everyday ease, while a private patio or deck with storage extends your space outdoors. Browse current availability, compare pricing, and choose the layout that fits how you want each day to flow—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorites in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the finish before you tour.</strong> This gallery brings The Heights at Happy Valley into focus through clean, light-filled rooms and shared spaces made for easy everyday use. Zoom in on kitchens with quartz-style surfaces, wood cabinetry, stainless-steel appliances, and breakfast-bar seating; then move through open living areas that extend toward private patios or decks. You’ll also catch the polished details that make a home feel complete, from modern baths to organized closets and in-home laundry.</p><p>Outside the apartment, the photos shift to the pool and spa, clubhouse lounge, fitness center, sauna, and outdoor gathering spots that give the Rock Creek setting its relaxed rhythm. When a photo catches your eye, explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Explore available apartments at The Heights at Happy Valley, then use the interactive map to see how Rock Creek green space, daily essentials, local dining, nature spots, and greater Portland connections come together around your new address.</p>",
  "property_pets_blurb": "<p><strong>Bring the routine you share.</strong> At The Heights at Happy Valley, cats and dogs are welcome, so your day can include window-perch lounging, quick outdoor breaks, and easy walks without leaving the rhythm of home. The on-site bark park gives dogs a dedicated place to stretch their legs, while connected walking paths and private patios or balconies in select homes make fresh air part of the everyday.</p><p>Inside, open layouts, spacious closets, in-home laundry, and durable vinyl flooring help keep pet gear, towels, toys, and cleanup manageable. When you want a bigger outing, nearby off-leash areas add more room for fetch and sniffing. Review the pet policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the pet-friendly spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share life at The Heights at Happy Valley.</strong> From brand-new one-, two-, and three-bedroom apartments with private outdoor space to PNW green space, connected trails, and inviting amenity spaces, there’s plenty to recommend. Send a friend your way and invite them to explore our <a href=\"/floor-plans\">available floor plans</a>.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong><br>Log in to manage life at The Heights at Happy Valley—pay rent, submit maintenance requests, and keep your account current, all in one convenient place at your brand-new Rock Creek apartment community.</p>",
  "property_reviews_blurb": "<p><strong>Resident feedback starts with service that feels attentive.</strong> Reviews for The Heights at Happy Valley highlight a smooth move-in experience, helpful leasing guidance, and a team that takes time to answer questions. Residents call out Hannah by name for going “above and beyond” and making the process feel easy.</p><p>You’ll also see praise for the property itself, from a “lovely” tour experience to clear explanations of the amenities. And when something needs attention, residents note fast, polite follow-through with care taken to make sure the fix is complete. Read the reviews below to see what people are saying firsthand.</p>",
  "property_created_at": "1788190144874",
  "property_scheduletour_blurb": "<p><strong>See brand-new Rock Creek apartments in person.</strong> Tour open one-, two-, and three-bedroom layouts with quartz countertops, stainless-steel appliances, in-home laundry, spacious closets, and private outdoor space—then picture how the 24/7 fitness center, sauna, pool, spa, and green surroundings fit your day.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture brand-new Rock Creek apartments with open layouts, quartz countertops, stainless-steel appliances, in-home laundry, private outdoor space, and PNW green space all around.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you arrive.</strong> The virtual tours at The Heights at Happy Valley let you move through the spaces that matter most, from The Heights Clubhouse to apartment walkthroughs for a 1 bedroom, 2x2 model, and 3 bedroom home. Look around at your own pace: trace the flow from open living areas to polished kitchens, zoom in on quartz countertops, stainless-steel appliances, cabinetry, closets, and in-home laundry, then picture how a patio or balcony could extend the room outdoors.</p><p>Use these immersive tours to narrow your favorite layouts, compare them with current <a href=\"/floor-plans\">floor plans</a>, and get a clearer feel for the community before you <a href=\"/schedule-a-tour\">schedule a tour</a> in person.</p>",
  "property_copyright": "2026 All Rights Reserved. The Heights at Happy Valley",
  "property_seo_title_home": "Happy Valley Apartments | The Heights at Happy Valley",
  "property_seo_description_home": "The Heights at Happy Valley offers new 1, 2 & 3 bedroom apartments and live-work units in Happy Valley, OR, near Mount Talbert Nature Park.",
  "property_seo_title_floorplans": "Happy Valley Apartments for Rent | 1, 2 & 3 Bedrooms",
  "property_seo_description_floorplans": "Explore 1, 2 & 3 bedroom apartments for rent in Happy Valley, OR, plus live-work units, at The Heights at Happy Valley. Find your floor plan today.",
  "property_seo_title_amenities": "Apartments Happy Valley, Oregon | Pool, Sauna & Amenities",
  "property_seo_description_amenities": "Apartments in Happy Valley, Oregon with a pool & spa, 24/7 fitness center & sauna, pickleball court, bark park & more at The Heights at Happy Valley.",
  "property_seo_title_gallery": "Apartments Happy Valley | Photo Gallery | The Heights",
  "property_seo_description_gallery": "Browse photos of The Heights at Happy Valley, from open-concept apartments and quartz kitchens to the pool, fitness center & nearby trails.",
  "property_seo_title_virtualtours": "New Apartments Happy Valley | Virtual Tours | The Heights",
  "property_seo_description_virtualtours": "Take a virtual tour of The Heights at Happy Valley and explore new 1, 2 & 3 bedroom apartments in Happy Valley, OR from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | The Heights at Happy Valley Apartments",
  "property_seo_description_interactivemap": "Find your perfect living space at The Heights at Happy Valley! With stunning amenities and an interactive map, your dream apartment is just a click away.",
  "property_seo_title_neighborhood": "Happy Valley, OR Apartments Near Mount Talbert Nature Park",
  "property_seo_description_neighborhood": "The Heights at Happy Valley offers Happy Valley, OR apartments near Mount Talbert Nature Park, Hidden Falls & Clackamas Town Center. Explore today!",
  "property_seo_title_contact": "Apartments for Rent Happy Valley, Oregon | Contact Us",
  "property_seo_description_contact": "Contact The Heights at Happy Valley about apartments for rent in Happy Valley, Oregon. Visit us at 17134 SE Rock Creek Blvd or call 855-652-0295.",
  "property_seo_title_faqs": "FAQs | Apartments in Happy Valley, OR",
  "property_seo_description_faqs": "Get the scoop on life at The Heights at Happy Valley! Our FAQs cover everything you need to know about amenities, floor plans, and our vibrant community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Happy Valley, OR",
  "property_seo_description_reviews": "Discover life at The Heights at Happy Valley! From vibrant spaces to savory amenities, see why our residents love calling this community home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Happy Valley, OR",
  "property_seo_description_applynow": "Elevate your lifestyle at The Heights at Happy Valley! Enjoy modern floor plans, top-notch amenities, and vibrant outdoor spaces. Lease your dream home today!",
  "property_seo_title_residentaccess": "Happy Valley Apartments | Resident Portal | The Heights",
  "property_seo_description_residentaccess": "Residents of The Heights at Happy Valley can pay rent, submit maintenance requests, and contact our team online through the resident portal.",
  "property_seo_title_referafriend": "Refer A Friend | The Heights at Happy Valley",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Heights at Happy Valley and enjoy life together in our vibrant community. Your new home awaits!",
  "property_seo_title_scheduletour": "Happy Valley Rentals | Schedule a Tour | The Heights",
  "property_seo_description_scheduletour": "Schedule a tour of The Heights at Happy Valley and see our new Happy Valley rentals, including 1, 2 & 3 bedroom apartments and live-work units.",
  "property_seo_title_privacy": "Privacy Policy | The Heights at Happy Valley",
  "property_seo_description_privacy": "Your privacy matters at The Heights at Happy Valley. Dive into our commitment to safeguarding your information. View our privacy policy for details!",
  "property_seo_title_accessibility": "Website Accessibility | The Heights at Happy Valley",
  "property_seo_description_accessibility": "At The Heights at Happy Valley, we embrace digital inclusion, ensuring accessible living for all and a seamless community experience.",
  "property_seo_title_sitemap": "Sitemap | The Heights at Happy Valley",
  "property_seo_description_sitemap": "Explore The Heights at Happy Valley! Use our sitemap for easy access to community features, amenities, and ideal places to call home.",
  "property_seo_title_thankyou": "Thank You | The Heights at Happy Valley",
  "property_seo_description_thankyou": "Thank you for contacting The Heights at Happy Valley! Our team will be in touch soon to elevate your living experience in Happy Valley, OR.",
  "property_seo_title_pets": "Pet Policy | Apartments in Happy Valley, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790871137426",
  "amenities": [
    {
      "id": "custom_24c162ad-4f70-4ef6-84d5-21462ad9b787",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse Lounge & Kitchen",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b08ce8d3-7958-43ee-8242-2637f3e1e3c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "24/7 Fitness Center & Sauna",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6608a955-84f1-433d-8979-42e6b5ed0cbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Pool & Spa",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d83d0936-a629-4dee-8e11-9c9e07964a04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Living Area With BBQ's",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd1c22ff-e32c-4150-930c-d3759dad3092",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Little Free Library",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f2df7b2-5ce1-400d-8e7d-372426a52c5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Sports Court",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d1d7703f-9f5a-426b-adde-4677838999c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9d77472b-2923-4643-89cd-0e25bd157cac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Work From Anywhere Space",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3f1ba176-5b01-4b05-ae32-56b239fd80cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_18fda478-03b9-4e09-8dd5-59cbcb319c0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9d070d4a-f8a9-4c29-95c7-dd31240d2cdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Disc Golf",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e777cc81-b8d5-4cd9-9a18-09865a48e94f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Access to Bike & Walking Trails",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3284b93-525d-42a6-8c8f-8fc152f19668",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Secure Mail & Package Room",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f2225864-ab58-408c-9faa-4a965bfea0a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_890cc619-c91c-4a1c-8087-96c183de83b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae2fbbe4-2803-44e5-8c78-6b8d5dc61e8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Retail Spaces Available",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_11d748ee-12bf-429f-945c-056c313a0714",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Resident You-Pick Herb Garden",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b46add5-29d9-4755-af96-73a665eec02c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floor Plans ",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7642118-7d22-4983-8c4f-f2fe0091cbdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Open-Concept Living ",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1190e8c7-4e35-4361-82a3-84c40db6edcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Soft-Close Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67744d8b-4d9d-443e-a992-3521515c4353",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29768a98-c9dd-4d3e-8786-7f4b0e3ac8d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel, Energy-Efficient Appliances ",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e446cebf-9a1f-44c1-b42c-4f07dda46a19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Abundant Kitchen Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f6efa61d-c37e-4258-9786-d7450e00dfb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Undermount Cabinet Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1040c6ea-a059-453f-8102-a4bd8a62c2da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer & Dryer ",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66d1f633-1fd6-412a-a12b-14597d726713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood-Style Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_edc5637d-02df-4cd7-bf49-a8d9679a48a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher & Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6778b95e-ef55-436c-881c-3a7a244cd6f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b86f7b3f-501a-4977-aa13-5044bf9f254d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Closets with Closet Systems in Primary Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7000babd-cd83-4c0c-9e09-b10ea0888d68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Deck with Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_65f1c4f5-e472-4bd3-8504-93a6a352e273",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08314-03d2-76db-8600-a8dc3f067b11.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, dresser, and TV.",
        "public_id": "01a08314-03d2-76db-8600-a8dc3f067b11",
        "storage_key": "property/6767906449167749/01a08314-03d2-76db-8600-a8dc3f067b11.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, a modern dresser with a television, and a large window with scenic views.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, dresser, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a8c66dc8-d8f2-4eae-bd22-be8c813df1fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08314-03be-70a8-b9af-ecf0bc73c6a6.webp",
      "image_media": {
        "alt_text": "A children's bedroom with bunk beds and a dresser.",
        "public_id": "01a08314-03be-70a8-b9af-ecf0bc73c6a6",
        "storage_key": "property/6767906449167749/01a08314-03be-70a8-b9af-ecf0bc73c6a6.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "This charming children's bedroom features comfortable bunk beds, a decorative dresser, and a playful polar bear rug.",
      "link": "",
      "alt_text": "A children's bedroom with bunk beds and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02bdddb5-49b2-45b6-9c1d-ffe93360cbef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08314-047d-7420-b0ab-e3abac788ba8.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, dresser, and TV.",
        "public_id": "01a08314-047d-7420-b0ab-e3abac788ba8",
        "storage_key": "property/6767906449167749/01a08314-047d-7420-b0ab-e3abac788ba8.webp",
        "width": 2048,
        "height": 1374
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a modern dresser, and a mounted flat-screen TV.",
      "link": "",
      "alt_text": "Bedroom with king-size bed, dresser, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0dc3e857-1d9f-432a-9712-8d0ad6f62fbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08314-03d3-76d8-a99c-a9f760c83299.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and island kitchen with bar stools.",
        "public_id": "01a08314-03d3-76d8-a99c-a9f760c83299",
        "storage_key": "property/6767906449167749/01a08314-03d3-76d8-a99c-a9f760c83299.webp",
        "width": 2048,
        "height": 1368
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a comfortable sectional sofa, elegant coffee table, and a contemporary kitchen island with seating.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa, coffee table, and island kitchen with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b52ebebc-02cd-4629-99cf-10ed3e72471f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-cdbf-75df-aff3-f137146b3abc.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a large bed, TV, and a window with a view.",
        "public_id": "01a08313-cdbf-75df-aff3-f137146b3abc",
        "storage_key": "property/6767906449167749/01a08313-cdbf-75df-aff3-f137146b3abc.webp",
        "width": 2048,
        "height": 1372
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom featuring a comfortable queen-size bed, a wall-mounted TV, and ample natural light from the large window.",
      "link": "",
      "alt_text": "Stylish bedroom with a large bed, TV, and a window with a view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8799eb28-bdec-4672-aea9-602ff4226a3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-cce6-7719-a64e-a69a760182c7.webp",
      "image_media": {
        "alt_text": "Modern living room with sectional couch, coffee table, and artwork.",
        "public_id": "01a08313-cce6-7719-a64e-a69a760182c7",
        "storage_key": "property/6767906449167749/01a08313-cce6-7719-a64e-a69a760182c7.webp",
        "width": 2048,
        "height": 1368
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room featuring a comfortable sectional sofa, a stylish coffee table, and tasteful artwork, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with sectional couch, coffee table, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_240b0cc8-95cc-48e9-97c9-bccb2cbff317",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-ccec-748f-93d8-8072487c7020.webp",
      "image_media": {
        "alt_text": "Living room and kitchen with modern furniture and stainless steel appliances.",
        "public_id": "01a08313-ccec-748f-93d8-8072487c7020",
        "storage_key": "property/6767906449167749/01a08313-ccec-748f-93d8-8072487c7020.webp",
        "width": 2048,
        "height": 1368
      },
      "title": "Apartment",
      "description": "Stylish living room and open-concept kitchen featuring a sofa, coffee table, modern cabinetry, and stainless steel appliances.",
      "link": "",
      "alt_text": "Living room and kitchen with modern furniture and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3e1d1eb9-20f0-43ab-b545-426a1f95e7a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-1674-716b-88d8-542fc2b05feb.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a dual vanity, large mirror, toilet, and shower with a striped curtain.",
        "public_id": "01a08313-1674-716b-88d8-542fc2b05feb",
        "storage_key": "property/6767906449167749/01a08313-1674-716b-88d8-542fc2b05feb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom featuring a spacious dual vanity, modern fixtures, and a refreshing shower area, designed for ultimate comfort.",
      "link": "",
      "alt_text": "Modern bathroom with a dual vanity, large mirror, toilet, and shower with a striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3411701f-a19a-44d6-943e-26b02715456d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-15bd-7590-bc49-35d5c75a831d.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, sliding closet doors, and modern art.",
        "public_id": "01a08313-15bd-7590-bc49-35d5c75a831d",
        "storage_key": "property/6767906449167749/01a08313-15bd-7590-bc49-35d5c75a831d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a plush queen bed, ample closet space, and stylish decor. Perfect for a restful night's sleep.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, sliding closet doors, and modern art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_341e9482-87cf-4a24-a38b-0261751f28ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-167b-773c-9273-65bb7ed9f9eb.webp",
      "image_media": {
        "alt_text": "Stackable in-unit washer and dryer",
        "public_id": "01a08313-167b-773c-9273-65bb7ed9f9eb",
        "storage_key": "property/6767906449167749/01a08313-167b-773c-9273-65bb7ed9f9eb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry access within your apartment home.",
      "link": "",
      "alt_text": "Stackable in-unit washer and dryer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a8ab790a-dc95-4345-a819-934911dd6d4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-046f-72b1-9221-6ba41d53c431.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, modern decor, and large window.",
        "public_id": "01a08313-046f-72b1-9221-6ba41d53c431",
        "storage_key": "property/6767906449167749/01a08313-046f-72b1-9221-6ba41d53c431.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax and unwind in this elegantly appointed bedroom, featuring a plush king-size bed, contemporary furnishings, and abundant natural light.",
      "link": "",
      "alt_text": "Spacious bedroom with a king-size bed, modern decor, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d9236d97-5ec8-47c4-8f00-b8c12f668759",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-081c-7003-baa4-5561a6b1f49f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a dark wood vanity, white countertop, stainless steel faucet, and a large mirror.",
        "public_id": "01a08313-081c-7003-baa4-5561a6b1f49f",
        "storage_key": "property/6767906449167749/01a08313-081c-7003-baa4-5561a6b1f49f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a spacious vanity, sleek fixtures, and a calming color palette.",
      "link": "",
      "alt_text": "Modern bathroom with a dark wood vanity, white countertop, stainless steel faucet, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4abee90f-bd62-4232-a332-41d1c42b9a08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-0943-7569-ade0-22f19860a6cd.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, desk, and artwork.",
        "public_id": "01a08313-0943-7569-ade0-22f19860a6cd",
        "storage_key": "property/6767906449167749/01a08313-0943-7569-ade0-22f19860a6cd.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in this elegantly furnished bedroom, featuring a comfortable queen-size bed, a dedicated workspace, and modern decor.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, desk, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d1280a6-61da-457e-a071-b31eef71b3ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-05a9-7246-a6e4-8ab833a96311.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a large bed, modern decor, and a view into the bathroom.",
        "public_id": "01a08313-05a9-7246-a6e4-8ab833a96311",
        "storage_key": "property/6767906449167749/01a08313-05a9-7246-a6e4-8ab833a96311.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a plush bed and elegant modern furnishings. The adjoining bathroom offers convenience and style.",
      "link": "",
      "alt_text": "Cozy bedroom with a large bed, modern decor, and a view into the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a843bb0-92a6-48ff-9007-9e6cf6d4f05e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-04d3-7466-9949-4a83b6c03b54.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, desk, and window.",
        "public_id": "01a08313-04d3-7466-9949-4a83b6c03b54",
        "storage_key": "property/6767906449167749/01a08313-04d3-7466-9949-4a83b6c03b54.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A stylish and comfortable bedroom featuring a plush bed, a modern desk area, and a large window with a scenic view.",
      "link": "",
      "alt_text": "Bedroom with a bed, desk, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2202ded3-b729-404e-84a2-5ecc85204738",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-06ec-7168-acea-0e8712771344.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with built-in shelving and hanging rods. View of a bathroom vanity with wood cabinets and a mirror.",
        "public_id": "01a08313-06ec-7168-acea-0e8712771344",
        "storage_key": "property/6767906449167749/01a08313-06ec-7168-acea-0e8712771344.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Organize your belongings in this generous walk-in closet, featuring ample shelving and hanging space. The adjacent bathroom offers a stylish vanity with wood cabinetry.",
      "link": "",
      "alt_text": "Spacious walk-in closet with built-in shelving and hanging rods. View of a bathroom vanity with wood cabinets and a mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5dfcadbd-303f-4dfc-b2ce-0ccfcbd5480a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-03a4-714e-b3ca-16be9e546d68.webp",
      "image_media": {
        "alt_text": "Balcony with table overlooking a street and buildings.",
        "public_id": "01a08313-03a4-714e-b3ca-16be9e546d68",
        "storage_key": "property/6767906449167749/01a08313-03a4-714e-b3ca-16be9e546d68.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, offering a scenic view of the surrounding area.",
      "link": "",
      "alt_text": "Balcony with table overlooking a street and buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f52d703-31e0-43d4-9ea8-392371a59df1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-03ca-749b-82c5-e6b1e0fbfd07.webp",
      "image_media": {
        "alt_text": "Balcony with a small table and chairs, door and window overlooking the street.",
        "public_id": "01a08313-03ca-749b-82c5-e6b1e0fbfd07",
        "storage_key": "property/6767906449167749/01a08313-03ca-749b-82c5-e6b1e0fbfd07.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on the private balcony, furnished with a table and chairs.",
      "link": "",
      "alt_text": "Balcony with a small table and chairs, door and window overlooking the street.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_adf9c594-cd9b-43a6-8fa8-c3a88229b155",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-fd79-71bb-bb17-82d07d830a3e.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and large window.",
        "public_id": "01a08312-fd79-71bb-bb17-82d07d830a3e",
        "storage_key": "property/6767906449167749/01a08312-fd79-71bb-bb17-82d07d830a3e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in style in this inviting living room, featuring plush seating, modern decor, and ample natural light.",
      "link": "",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ce2be25-4b78-4877-b73a-8043bbcb8450",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08313-0154-736b-9fb7-5c795d94c8f9.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and dining area.",
        "public_id": "01a08313-0154-736b-9fb7-5c795d94c8f9",
        "storage_key": "property/6767906449167749/01a08313-0154-736b-9fb7-5c795d94c8f9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring a comfortable sectional sofa, a stylish coffee table, and an adjacent dining space, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2b52e45e-f5bb-4800-b12b-51086c33ebbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-ef5b-70f8-bd1e-acfaeb58302b.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, TV, and coffee table.",
        "public_id": "01a08312-ef5b-70f8-bd1e-acfaeb58302b",
        "storage_key": "property/6767906449167749/01a08312-ef5b-70f8-bd1e-acfaeb58302b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy this stylish living room featuring a comfortable sectional sofa, a modern media console with a large TV, and a chic coffee table. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa, TV, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8a582cac-40ce-4b98-b58e-5cd278f57fe9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-ef64-7648-999c-dfffcdb6fad9.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with sectional sofa, coffee table, dining set, and entertainment center.",
        "public_id": "01a08312-ef64-7648-999c-dfffcdb6fad9",
        "storage_key": "property/6767906449167749/01a08312-ef64-7648-999c-dfffcdb6fad9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a comfortable sectional, a sleek entertainment center with a large TV, and a modern kitchen with stainless steel appliances and a breakfast bar.",
      "link": "",
      "alt_text": "Modern living room and kitchen with sectional sofa, coffee table, dining set, and entertainment center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_26189071-9590-4d4d-8a77-ad2f7da86a42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-ef0c-71c4-8a91-d1c46f53b597.webp",
      "image_media": {
        "alt_text": "Modern dining area and kitchen island with bar stools in an apartment.",
        "public_id": "01a08312-ef0c-71c4-8a91-d1c46f53b597",
        "storage_key": "property/6767906449167749/01a08312-ef0c-71c4-8a91-d1c46f53b597.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy a stylish dining experience with this open-concept layout, featuring a sleek dining table and a breakfast bar perfect for entertaining.",
      "link": "",
      "alt_text": "Modern dining area and kitchen island with bar stools in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_65ebfcfb-632f-4288-9352-fa4deb42a9bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-eb9f-726e-af25-6d77be1dfb2a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wood cabinets.",
        "public_id": "01a08312-eb9f-726e-af25-6d77be1dfb2a",
        "storage_key": "property/6767906449167749/01a08312-eb9f-726e-af25-6d77be1dfb2a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and a sleek countertop. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a14e9e3-ea93-425e-89f5-81eca8d5bba7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-ebff-71f1-821a-8b306d9a175d.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, TV, and entryway.",
        "public_id": "01a08312-ebff-71f1-821a-8b306d9a175d",
        "storage_key": "property/6767906449167749/01a08312-ebff-71f1-821a-8b306d9a175d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring a comfortable sofa, stylish coffee table, and entertainment center, with an adjacent entryway.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, TV, and entryway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e304cf87-30b4-4b8c-baee-08be30b64ad8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-ebea-756a-8644-48b063afaacb.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with sink, dishwasher, and wood cabinetry. Open to living area.",
        "public_id": "01a08312-ebea-756a-8644-48b063afaacb",
        "storage_key": "property/6767906449167749/01a08312-ebea-756a-8644-48b063afaacb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a spacious island with a sink and dishwasher, ample cabinetry, and an open flow to the living room.",
      "link": "",
      "alt_text": "Modern kitchen island with sink, dishwasher, and wood cabinetry. Open to living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd4156f2-83fb-4bd1-8b9d-e614ab050a49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-eb24-71d4-9dad-fd29f67d68af.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with a sink and faucet in a bright living space.",
        "public_id": "01a08312-eb24-71d4-9dad-fd29f67d68af",
        "storage_key": "property/6767906449167749/01a08312-eb24-71d4-9dad-fd29f67d68af.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious and contemporary kitchen featuring a large island with a stainless steel sink and a sleek faucet, seamlessly flowing into the living area.",
      "link": "",
      "alt_text": "Modern kitchen island with a sink and faucet in a bright living space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7e01f356-cfb2-40e5-ae51-74a342197a32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-eb74-7749-8635-286eb14f0f93.webp",
      "image_media": {
        "alt_text": "Modern open-concept living area with kitchen island and TV.",
        "public_id": "01a08312-eb74-7749-8635-286eb14f0f93",
        "storage_key": "property/6767906449167749/01a08312-eb74-7749-8635-286eb14f0f93.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed apartment, featuring a modern open-concept living space with a sleek kitchen island, perfect for entertaining, and a spacious living room with a mounted TV.",
      "link": "",
      "alt_text": "Modern open-concept living area with kitchen island and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dbe1eeb3-4b51-4526-b819-602331ad94a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-eb31-70ab-84cc-bf7588e28f95.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "01a08312-eb31-70ab-84cc-bf7588e28f95",
        "storage_key": "property/6767906449167749/01a08312-eb31-70ab-84cc-bf7588e28f95.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a spacious island with bar seating, sleek dark wood cabinetry, and stainless steel appliances, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with island, stainless steel appliances, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f90ddffc-0c52-476a-bb5b-1d0b6d3f2d21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-eafb-717a-b9b4-92ec00511d44.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wood cabinetry.",
        "public_id": "01a08312-eafb-717a-b9b4-92ec00511d44",
        "storage_key": "property/6767906449167749/01a08312-eafb-717a-b9b4-92ec00511d44.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Chic kitchen featuring stainless steel appliances, a deep sink, and warm wood cabinetry, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and wood cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b6b79f4e-8529-473e-b07a-876d28f325cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-a33c-76fa-9a86-e4638794ec58.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building's modern blue and white facade with balconies and staircases.",
        "public_id": "01a08312-a33c-76fa-9a86-e4638794ec58",
        "storage_key": "property/6767906449167749/01a08312-a33c-76fa-9a86-e4638794ec58.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Showcasing the contemporary architecture of the apartment building, featuring stylish balconies and convenient outdoor stair access.",
      "link": "",
      "alt_text": "Exterior view of the apartment building's modern blue and white facade with balconies and staircases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_88b0ede2-8713-4539-8b1f-2c716b4a46ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-9dc4-73ad-b4b9-b87b8b510ab5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with blue and white siding, balconies, and a parking lot.",
        "public_id": "01a08312-9dc4-73ad-b4b9-b87b8b510ab5",
        "storage_key": "property/6767906449167749/01a08312-9dc4-73ad-b4b9-b87b8b510ab5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Modern apartment buildings featuring blue and white exteriors, private balconies, and ample parking. Enjoy comfortable living in a well-maintained community.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with blue and white siding, balconies, and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a19165dc-2f5c-49d0-8bcb-6b32b6662b09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-9dd9-72ad-9be3-4d14212180e8.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily apartment building with covered parking and a red truck.",
        "public_id": "01a08312-9dd9-72ad-9be3-4d14212180e8",
        "storage_key": "property/6767906449167749/01a08312-9dd9-72ad-9be3-4d14212180e8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Modern multifamily apartment building exterior featuring covered parking and landscaping. Offers a view of the property's design and amenities.",
      "link": "",
      "alt_text": "Exterior of a multifamily apartment building with covered parking and a red truck.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a2a156cb-2b9e-47b1-a43e-0d228a68362b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-9dce-72d6-b6c3-1baa3822c38c.webp",
      "image_media": {
        "alt_text": "Fitness room with large exercise balls and view of outdoor pool and apartment buildings.",
        "public_id": "01a08312-9dce-72d6-b6c3-1baa3822c38c",
        "storage_key": "property/6767906449167749/01a08312-9dce-72d6-b6c3-1baa3822c38c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with everything you need for a great workout. Enjoy the view of the pool and community grounds.",
      "link": "",
      "alt_text": "Fitness room with large exercise balls and view of outdoor pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f5d15223-3174-42d3-87b5-f7e35f05e228",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-9afe-72bb-8366-ee9f3d0bdd9e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with blue and white siding, a paved parking lot, and a clubhouse.",
        "public_id": "01a08312-9afe-72bb-8366-ee9f3d0bdd9e",
        "storage_key": "property/6767906449167749/01a08312-9afe-72bb-8366-ee9f3d0bdd9e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Discover modern apartment living with our beautifully designed exteriors and welcoming community spaces. Enjoy the convenience of ample parking and the charm of our clubhouse.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with blue and white siding, a paved parking lot, and a clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea0b683c-1c11-41ba-bc2b-38c03db50033",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-9aa6-74be-92b0-3f033ea8be92.webp",
      "image_media": {
        "alt_text": "Fitness center with weights, medicine balls, and exercise bands.",
        "public_id": "01a08312-9aa6-74be-92b0-3f033ea8be92",
        "storage_key": "property/6767906449167749/01a08312-9aa6-74be-92b0-3f033ea8be92.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring free weights, medicine balls, and resistance bands for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with weights, medicine balls, and exercise bands.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c52b8e3-b526-487a-8d6f-355659e42581",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-99d1-7795-8c6d-51604dcd53d0.webp",
      "image_media": {
        "alt_text": "Gym with large exercise balls on a rack and dumbbells on a rack.",
        "public_id": "01a08312-99d1-7795-8c6d-51604dcd53d0",
        "storage_key": "property/6767906449167749/01a08312-99d1-7795-8c6d-51604dcd53d0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Modern gym facility with exercise balls and weights, featuring large windows and wood flooring.",
      "link": "",
      "alt_text": "Gym with large exercise balls on a rack and dumbbells on a rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4e7ba87e-e1b9-4a8c-83f8-649f5a1d8016",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-9538-7045-9eaa-4fae88b35df4.webp",
      "image_media": {
        "alt_text": "Interior of a clean wooden sauna with tiered benches and a heater.",
        "public_id": "01a08312-9538-7045-9eaa-4fae88b35df4",
        "storage_key": "property/6767906449167749/01a08312-9538-7045-9eaa-4fae88b35df4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our community's spacious sauna, perfect for de-stressing after a workout or a long day.",
      "link": "",
      "alt_text": "Interior of a clean wooden sauna with tiered benches and a heater.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9abea54c-ccaa-4a47-9006-16b767c09f73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-864f-731b-9cb2-38bc4e4b44b2.webp",
      "image_media": {
        "alt_text": "Modern seating area with tables and chairs overlooking apartment buildings.",
        "public_id": "01a08312-864f-731b-9cb2-38bc4e4b44b2",
        "storage_key": "property/6767906449167749/01a08312-864f-731b-9cb2-38bc4e4b44b2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a moment of relaxation in our comfortable seating area, offering scenic views of the surrounding community.",
      "link": "",
      "alt_text": "Modern seating area with tables and chairs overlooking apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_176f6c0c-975f-4ad5-a62c-40b8844c31c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-8f72-773a-96dc-75e7382565d6.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, treadmills, and dumbbells.",
        "public_id": "01a08312-8f72-773a-96dc-75e7382565d6",
        "storage_key": "property/6767906449167749/01a08312-8f72-773a-96dc-75e7382565d6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Gym with weight machines, treadmills, and dumbbells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fb4ec492-326a-460e-81cc-7a238f477b5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-8be7-77b8-840c-bb14e4831a15.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "01a08312-8be7-77b8-840c-bb14e4831a15",
        "storage_key": "property/6767906449167749/01a08312-8be7-77b8-840c-bb14e4831a15.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines and strength training equipment for residents.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_276fe8c1-5b38-41a6-b248-ba68f15e648f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-8604-755e-851d-4088b77ce721.webp",
      "image_media": {
        "alt_text": "Modern kitchen area with sleek cabinets, marble backsplash, and stainless steel appliances.",
        "public_id": "01a08312-8604-755e-851d-4088b77ce721",
        "storage_key": "property/6767906449167749/01a08312-8604-755e-851d-4088b77ce721.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the modern amenities in our community kitchen, featuring sleek cabinetry, a stylish marble backsplash, and top-of-the-line stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen area with sleek cabinets, marble backsplash, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e037a9bf-9a15-4770-a5ff-bf3bdea10868",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-83f2-70cc-8465-3658d415f580.webp",
      "image_media": {
        "alt_text": "Community lounge area with a large island, seating, and large windows overlooking the exterior.",
        "public_id": "01a08312-83f2-70cc-8465-3658d415f580",
        "storage_key": "property/6767906449167749/01a08312-83f2-70cc-8465-3658d415f580.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Modern community lounge featuring a large kitchen island, ample seating, and expansive windows with views of the property's exterior amenities and buildings.",
      "link": "",
      "alt_text": "Community lounge area with a large island, seating, and large windows overlooking the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c69f2ba6-e111-4f96-90b7-5387e6a1cda4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-83e4-72ae-9cc0-f59b354108d5.webp",
      "image_media": {
        "alt_text": "Modern community kitchen area with island seating and large windows.",
        "public_id": "01a08312-83e4-72ae-9cc0-f59b354108d5",
        "storage_key": "property/6767906449167749/01a08312-83e4-72ae-9cc0-f59b354108d5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our stylish community kitchen, perfect for entertaining or casual gatherings, featuring a large island, modern appliances, and ample seating.",
      "link": "",
      "alt_text": "Modern community kitchen area with island seating and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d565dd54-1d2e-4a07-a282-3ff6797b9d6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-8337-76f6-ba74-ebf0f32a99eb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with large island, stainless steel appliances, and marble backsplash.",
        "public_id": "01a08312-8337-76f6-ba74-ebf0f32a99eb",
        "storage_key": "property/6767906449167749/01a08312-8337-76f6-ba74-ebf0f32a99eb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A stylish, modern kitchen featuring a large central island with a microwave, sleek cabinetry, and a beautiful marble backsplash. Perfect for entertaining or everyday use.",
      "link": "",
      "alt_text": "Modern kitchen with large island, stainless steel appliances, and marble backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_56952a44-b5f9-416e-9aa8-68ac58cea5ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-8452-71cb-9d1c-603d62ee473f.webp",
      "image_media": {
        "alt_text": "Stainless steel sink with a modern faucet against a marble backsplash.",
        "public_id": "01a08312-8452-71cb-9d1c-603d62ee473f",
        "storage_key": "property/6767906449167749/01a08312-8452-71cb-9d1c-603d62ee473f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A close-up view of a stylish stainless steel sink, featuring a high-arc faucet and elegant marble accents on the backsplash and countertop.",
      "link": "",
      "alt_text": "Stainless steel sink with a modern faucet against a marble backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fcf4acb9-1cd8-42b5-a370-264e60a753c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-8859-745f-a922-2370c7b3d687.webp",
      "image_media": {
        "alt_text": "Spacious apartment gym with cardio machines and weight training equipment.",
        "public_id": "01a08312-8859-745f-a922-2370c7b3d687",
        "storage_key": "property/6767906449167749/01a08312-8859-745f-a922-2370c7b3d687.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Spacious apartment gym with cardio machines and weight training equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d786575-1f4f-465d-8b3b-76107d4d6f2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-86d0-739f-8f83-24a6412dde1b.webp",
      "image_media": {
        "alt_text": "Desk and chair in a small office space with a window overlooking the exterior.",
        "public_id": "01a08312-86d0-739f-8f83-24a6412dde1b",
        "storage_key": "property/6767906449167749/01a08312-86d0-739f-8f83-24a6412dde1b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this comfortable home office nook. Features a built-in desk and ample natural light from the window.",
      "link": "",
      "alt_text": "Desk and chair in a small office space with a window overlooking the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10a9e304-c4e2-4f0a-87af-5e130d198a03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-7203-750a-a529-a32442639ab3.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with a stone fireplace, TV, and comfortable seating.",
        "public_id": "01a08312-7203-750a-a529-a32442639ab3",
        "storage_key": "property/6767906449167749/01a08312-7203-750a-a529-a32442639ab3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a beautiful stone fireplace, a large screen TV, and plush seating perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Modern community lounge area with a stone fireplace, TV, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57f9ac2f-cd85-4bb3-a65e-12f5b10736c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-74c8-7571-b034-00b53ef957eb.webp",
      "image_media": {
        "alt_text": "Spacious modern lobby with a stone accent wall, fireplace, large sectional sofa, and contemporary decor.",
        "public_id": "01a08312-74c8-7571-b034-00b53ef957eb",
        "storage_key": "property/6767906449167749/01a08312-74c8-7571-b034-00b53ef957eb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to our inviting community lobby, featuring a striking stone fireplace, comfortable seating, and elegant decor, perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Spacious modern lobby with a stone accent wall, fireplace, large sectional sofa, and contemporary decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab5dcd07-e02e-48a7-aaef-653a5e73e518",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-6fb5-7553-ae46-aa52591074e4.webp",
      "image_media": {
        "alt_text": "Lobby area with modern furniture, large windows, and decorative lighting.",
        "public_id": "01a08312-6fb5-7553-ae46-aa52591074e4",
        "storage_key": "property/6767906449167749/01a08312-6fb5-7553-ae46-aa52591074e4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to our spacious and inviting lobby, featuring comfortable seating, stylish decor, and ample natural light. A perfect space to relax or greet guests.",
      "link": "",
      "alt_text": "Lobby area with modern furniture, large windows, and decorative lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_422c7772-a1ec-48a8-a90c-587ceb53218c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-7109-7762-bb25-54dd45cf4dec.webp",
      "image_media": {
        "alt_text": "Modern common area kitchen with island seating, full-size refrigerator, and sleek cabinetry.",
        "public_id": "01a08312-7109-7762-bb25-54dd45cf4dec",
        "storage_key": "property/6767906449167749/01a08312-7109-7762-bb25-54dd45cf4dec.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a spacious and modern common area, perfect for socializing or working. This space features a fully equipped kitchen, a large island with bar seating, and elegant finishes.",
      "link": "",
      "alt_text": "Modern common area kitchen with island seating, full-size refrigerator, and sleek cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4783925d-df60-41d3-9665-4eb779274210",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-70b6-742c-9a0c-acdbb570e0f8.webp",
      "image_media": {
        "alt_text": "Modern lobby with high ceilings, comfortable seating, and a reception desk.",
        "public_id": "01a08312-70b6-742c-9a0c-acdbb570e0f8",
        "storage_key": "property/6767906449167749/01a08312-70b6-742c-9a0c-acdbb570e0f8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to our spacious and modern lobby, designed for comfort and convenience with ample seating and a professional reception area.",
      "link": "",
      "alt_text": "Modern lobby with high ceilings, comfortable seating, and a reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae751210-92e2-4e6e-9d01-9ea335457b52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-719b-71ed-8024-9fded7a01b6e.webp",
      "image_media": {
        "alt_text": "Office reception desk with computer and chairs, view of apartments and trees through window.",
        "public_id": "01a08312-719b-71ed-8024-9fded7a01b6e",
        "storage_key": "property/6767906449167749/01a08312-719b-71ed-8024-9fded7a01b6e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Bright and modern office reception area with a computer, printer, and comfortable seating. Large windows offer a view of the surrounding apartment buildings and landscaping.",
      "link": "",
      "alt_text": "Office reception desk with computer and chairs, view of apartments and trees through window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf0e22cb-3552-4055-9b35-af9e3bbc0ac5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-6f8f-75f4-b589-764e82d6800c.webp",
      "image_media": {
        "alt_text": "Modern leasing office reception desk with chairs and a door leading to an office.",
        "public_id": "01a08312-6f8f-75f4-b589-764e82d6800c",
        "storage_key": "property/6767906449167749/01a08312-6f8f-75f4-b589-764e82d6800c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome guests at our modern leasing office, featuring a comfortable reception desk and seating area.",
      "link": "",
      "alt_text": "Modern leasing office reception desk with chairs and a door leading to an office.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c52f6852-9c2e-443a-bf8b-4a6c1484a97c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-6f3d-76df-a637-08171ad4f1de.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a large stone fireplace, two sofas, and a coffee table.",
        "public_id": "01a08312-6f3d-76df-a637-08171ad4f1de",
        "storage_key": "property/6767906449167749/01a08312-6f3d-76df-a637-08171ad4f1de.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, featuring a striking stone fireplace and comfortable seating areas.",
      "link": "",
      "alt_text": "Spacious community lounge with a large stone fireplace, two sofas, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a14fff5c-d2c2-4495-b8bf-9150061a2462",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-6f4f-703c-bb29-d66e31ab2a00.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment complex lobby with a large stone fireplace, comfortable seating areas, and a communal workspace.",
        "public_id": "01a08312-6f4f-703c-bb29-d66e31ab2a00",
        "storage_key": "property/6767906449167749/01a08312-6f4f-703c-bb29-d66e31ab2a00.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Experience the inviting atmosphere of our community lobby, featuring a grand stone fireplace, stylish lounge areas, and a dedicated workspace perfect for residents.",
      "link": "",
      "alt_text": "Interior of a modern apartment complex lobby with a large stone fireplace, comfortable seating areas, and a communal workspace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a857f265-aca9-4eb5-8a1b-ef6895696ad9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-6f4f-703c-bb29-d3fd1b5d54fd.webp",
      "image_media": {
        "alt_text": "Modern leasing office with fireplace and seating area",
        "public_id": "01a08312-6f4f-703c-bb29-d3fd1b5d54fd",
        "storage_key": "property/6767906449167749/01a08312-6f4f-703c-bb29-d3fd1b5d54fd.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome guests into our modern leasing office, featuring a grand stone fireplace and comfortable seating areas.",
      "link": "",
      "alt_text": "Modern leasing office with fireplace and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_97b13f84-5e22-4c1e-96bb-f27cee3052d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabd-4927-722d-b4d6-2ce59e67268e.webp",
      "image_media": {
        "alt_text": "Aerial view of multifamily apartment buildings with a pool and tennis courts.",
        "public_id": "01a0dabd-4927-722d-b4d6-2ce59e67268e",
        "storage_key": "property/6767906449167749/01a0dabd-4927-722d-b4d6-2ce59e67268e.webp",
        "width": 3000,
        "height": 1688
      },
      "title": "Community",
      "description": "Aerial view of a modern multifamily apartment complex featuring multiple buildings, a swimming pool, and tennis courts, surrounded by landscaping and parking areas.",
      "link": "",
      "alt_text": "Aerial view of multifamily apartment buildings with a pool and tennis courts.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_07a2d8a1-930a-4c60-82ce-0171d8e77613",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabd-4543-75b9-afc9-2044db4d6a2b.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with apartment buildings, a pool, parking lots, and surrounding landscaping.",
        "public_id": "01a0dabd-4543-75b9-afc9-2044db4d6a2b",
        "storage_key": "property/6767906449167749/01a0dabd-4543-75b9-afc9-2044db4d6a2b.webp",
        "width": 3000,
        "height": 1688
      },
      "title": "Community",
      "description": "An aerial view showcases a modern multifamily property featuring apartment buildings, a sparkling outdoor pool, ample parking, and well-maintained landscaping, offering a glimpse into community amenities and exterior design.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with apartment buildings, a pool, parking lots, and surrounding landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d9e1ffdf-af81-4aa4-a201-b134e5b75420",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabd-14cc-742f-92bf-78a843228268.webp",
      "image_media": {
        "alt_text": "A resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
        "public_id": "01a0dabd-14cc-742f-92bf-78a843228268",
        "storage_key": "property/6767906449167749/01a0dabd-14cc-742f-92bf-78a843228268.webp",
        "width": 3000,
        "height": 1688
      },
      "title": "Community",
      "description": "Dive into relaxation at our sparkling swimming pool and soothing hot tub, surrounded by comfortable lounge chairs and shaded umbrellas. Enjoy the perfect outdoor oasis.",
      "link": "",
      "alt_text": "A resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_db850c3d-8c11-46cb-85c3-048b72692ae8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabd-154f-7419-a19c-246ca746df63.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with a blue accent building featuring a grill area.",
        "public_id": "01a0dabd-154f-7419-a19c-246ca746df63",
        "storage_key": "property/6767906449167749/01a0dabd-154f-7419-a19c-246ca746df63.webp",
        "width": 3000,
        "height": 1688
      },
      "title": "Community",
      "description": "Modern apartment complex exterior with a communal grilling area and spacious outdoor spaces, showcasing attractive architecture and landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with a blue accent building featuring a grill area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_095c5d28-fa98-4924-8b0e-c8d9a9f7d229",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabd-15ff-765b-a278-0447ebebf44c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings showing balconies, windows, and an outdoor stairwell.",
        "public_id": "01a0dabd-15ff-765b-a278-0447ebebf44c",
        "storage_key": "property/6767906449167749/01a0dabd-15ff-765b-a278-0447ebebf44c.webp",
        "width": 3000,
        "height": 1688
      },
      "title": "Community",
      "description": "View of the exterior of apartment buildings, showcasing individual balconies, windows, and an external stairwell, highlighting the property's architecture.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings showing balconies, windows, and an outdoor stairwell.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e5b994cf-a2a1-4016-bbcc-a26fea47707e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabd-05aa-750c-970f-341de3162ab5.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with pool, covered parking, and sports courts.",
        "public_id": "01a0dabd-05aa-750c-970f-341de3162ab5",
        "storage_key": "property/6767906449167749/01a0dabd-05aa-750c-970f-341de3162ab5.webp",
        "width": 3000,
        "height": 1688
      },
      "title": "Community",
      "description": "Explore this apartment community featuring a sparkling swimming pool, convenient covered parking, and recreational sports courts. A perfect place to call home!",
      "link": "",
      "alt_text": "Aerial view of apartment complex with pool, covered parking, and sports courts.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1ef1075-6a63-4f65-99fc-4265aaeb98d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabc-feec-76de-ac25-4bb8bf1c0e6d.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with pool, spa, and tennis court.",
        "public_id": "01a0dabc-feec-76de-ac25-4bb8bf1c0e6d",
        "storage_key": "property/6767906449167749/01a0dabc-feec-76de-ac25-4bb8bf1c0e6d.webp",
        "width": 3000,
        "height": 1688
      },
      "title": "Community",
      "description": "Spacious aerial view showcasing a modern apartment complex with a sparkling swimming pool, relaxing spa, and a newly built tennis court. Enjoy resort-style living.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with pool, spa, and tennis court.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0223ffc1-c094-4fd0-83e6-27ce6d23bae7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabd-05fa-7514-a8ba-c6f22d73509d.webp",
      "image_media": {
        "alt_text": "Exterior of modern apartment building with blue and white facade.",
        "public_id": "01a0dabd-05fa-7514-a8ba-c6f22d73509d",
        "storage_key": "property/6767906449167749/01a0dabd-05fa-7514-a8ba-c6f22d73509d.webp",
        "width": 3000,
        "height": 1688
      },
      "title": "Community",
      "description": "Exterior of a contemporary apartment building featuring a striking blue and white facade, with large windows and a prominent entrance.",
      "link": "",
      "alt_text": "Exterior of modern apartment building with blue and white facade.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4f885bf6-6359-44b7-a86f-72ccc8b506ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabc-f60d-72de-9715-51552c0010a5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with multiple balconies and exterior staircases.",
        "public_id": "01a0dabc-f60d-72de-9715-51552c0010a5",
        "storage_key": "property/6767906449167749/01a0dabc-f60d-72de-9715-51552c0010a5.webp",
        "width": 3000,
        "height": 1688
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring balconies, exterior staircases, and a mix of light and dark blue siding.",
      "link": "",
      "alt_text": "Exterior view of apartment building with multiple balconies and exterior staircases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d22f9e3b-bd0d-4f0b-b05d-fd4fdd0df90e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05871-7bf1-779f-bd19-9f114353c8cf.webp",
      "image_media": {
        "alt_text": "A wood desk with a lamp and chair in a room with a window overlooking apartments.",
        "public_id": "01a05871-7bf1-779f-bd19-9f114353c8cf",
        "storage_key": "property/6767906449167749/01a05871-7bf1-779f-bd19-9f114353c8cf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A well-lit workspace with a desk, lamp, and chair, offering a view of the surrounding apartment buildings.",
      "link": "",
      "alt_text": "A wood desk with a lamp and chair in a room with a window overlooking apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_745ec327-3921-4238-bb15-5d97de0e5c92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05871-7a43-7529-99db-23e3639d8589.webp",
      "image_media": {
        "alt_text": "Gym with weights, medicine balls, and resistance bands",
        "public_id": "01a05871-7a43-7529-99db-23e3639d8589",
        "storage_key": "property/6767906449167749/01a05871-7a43-7529-99db-23e3639d8589.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring free weights, medicine balls, and resistance bands for a complete workout.",
      "link": "",
      "alt_text": "Gym with weights, medicine balls, and resistance bands",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f9bcd1e1-73c2-47c6-b427-b55b30127841",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Sichuan City | Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11342 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "Casual venue with a menu of classics, from fried rice to mapo tofu, plus spicy choices, including kung pao chicken.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-812f-718c-bc74-94589a9c1e93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-812f-718c-bc74-94589a9c1e93",
        "storage_key": "property/6767906449167749/01a05872-812f-718c-bc74-94589a9c1e93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://sichuanct.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=10534880535571906890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sichuan-city--chinese-restaurant",
      "poi_latitude": "45.4424691",
      "poi_longitude": "-122.5771136",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-305-6879",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWVmONNp1lVQRSsHw6QdqM5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_0b338db9-c080-4a9b-b069-be2123490d73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Sakura Yakitori and Sushi",
      "poi_type": "Restaurants",
      "poi_address": "13200 SE 172nd Ave Ste 158, Happy Valley, OR 97086, USA",
      "poi_short_description": "Sushi and other Japanese fare served in a hip space featuring a cherry blossom tree.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8008-75c9-b170-6a3d82332c9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8008-75c9-b170-6a3d82332c9c",
        "storage_key": "property/6767906449167749/01a05872-8008-75c9-b170-6a3d82332c9c.webp",
        "width": 1280,
        "height": 659
      },
      "poi_business_url": "https://www.sakurayakitoriandsushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16598057854415497608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sakura-yakitori-and-sushi",
      "poi_latitude": "45.42669590000001",
      "poi_longitude": "-122.4852459",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-427-0313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgQCT4SOflVQRiGnRpa0lWOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c8b8ee7c-9757-4ba4-8b22-18bcc1d0aca8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Laughing Planet",
      "poi_type": "Restaurants",
      "poi_address": "10225 SE Sunnyside Rd, Happy Valley, OR 97015, USA",
      "poi_short_description": "Health-minded, counter-serve chain featuring creative, globally influenced bowls & burritos.",
      "poi_long_description": "Health-minded, counter-serve chain featuring creative, globally influenced bowls & burritos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-89df-729d-97c6-79cda585395d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-89df-729d-97c6-79cda585395d",
        "storage_key": "property/6767906449167749/01a05872-89df-729d-97c6-79cda585395d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://laughingplanet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15969347930667240996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "laughing-planet",
      "poi_latitude": "45.4337305",
      "poi_longitude": "-122.5589113",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-303-4633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2m-Jp11lVQRJE4KblWFnt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b8e334e1-40fa-4143-92b7-e863517f7ac0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Biscuits Cafe",
      "poi_type": "Restaurants",
      "poi_address": "17015 SE Sunnyside Rd Suite 124, Happy Valley, OR 97086, USA",
      "poi_short_description": "Low-key chain venue offering familiar American fare for breakfast & lunch, plus free WiFi.",
      "poi_long_description": "Low-key chain venue offering familiar American fare for breakfast & lunch, plus free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8655-761a-992a-113360212d4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8655-761a-992a-113360212d4f",
        "storage_key": "property/6767906449167749/01a05872-8655-761a-992a-113360212d4f.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://biscuitscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17231369877762944661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biscuits-cafe",
      "poi_latitude": "45.4270989",
      "poi_longitude": "-122.4885105",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-427-2149",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr36oUnqelVQRlS5trZsfIu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_98456632-2260-4223-b3c8-a96ab7c12cee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "MOD Pizza",
      "poi_type": "Restaurants",
      "poi_address": "12091 SE Sunnyside Rd, Happy Valley, OR 97015, USA",
      "poi_short_description": "Counter-serve, industrial-chic chain restaurant known for build-your-own pizzas.",
      "poi_long_description": "Counter-serve, industrial-chic chain restaurant known for build-your-own pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-80e8-735c-a580-9fe4d387c3ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-80e8-735c-a580-9fe4d387c3ee",
        "storage_key": "property/6767906449167749/01a05872-80e8-735c-a580-9fe4d387c3ee.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.modpizza.com/usa/or/happy-valley/12091-se-sunnyside-rd?utm_source=google&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17925072700191590659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mod-pizza",
      "poi_latitude": "45.42956",
      "poi_longitude": "-122.538609",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-486-6309",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1_hK9COelVQRA8n4U6amwvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_26f36bab-4c94-4acb-addd-a2c66f20282b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Five Guys",
      "poi_type": "Restaurants",
      "poi_address": "17105 SE Sunnyside Rd Ste 134, Happy Valley, OR 97086, USA",
      "poi_short_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_long_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8391-769a-91a7-f40344f1a595.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8391-769a-91a7-f40344f1a595",
        "storage_key": "property/6767906449167749/01a05872-8391-769a-91a7-f40344f1a595.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://restaurants.fiveguys.com/17105-se-sunnyside-drive",
      "poi_directions_map_url": "https://maps.google.com/?cid=11641017767484050350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-guys",
      "poi_latitude": "45.4268651",
      "poi_longitude": "-122.4873177",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-342-1756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xpv23uelVQRrsvllvszjaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3414f5e4-7ba7-4d92-954f-5a50470df92b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "17015 SE Sunnyside Rd, Happy Valley, OR 97015, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-869c-75b2-b320-754bf10aeca0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-869c-75b2-b320-754bf10aeca0",
        "storage_key": "property/6767906449167749/01a05872-869c-75b2-b320-754bf10aeca0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/or/happy-valley/17015-se-sunnyside-rd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2862",
      "poi_directions_map_url": "https://maps.google.com/?cid=12522376793429663435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "45.4271059",
      "poi_longitude": "-122.488994",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-558-9116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xpv23uelVQRy17441hryK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_116762cf-433e-4114-b313-6cce405b09ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Jersey Mike's Subs",
      "poi_type": "Restaurants",
      "poi_address": "17015 SE Sunnyside Rd, Happy Valley, OR 97015, USA",
      "poi_short_description": "New Jersey–based counter-serve sandwich chain serving jumbo subs filled with cold cuts & toppings.",
      "poi_long_description": "New Jersey–based counter-serve sandwich chain serving jumbo subs filled with cold cuts & toppings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-88b7-763f-bb7f-b60c9c098798.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-88b7-763f-bb7f-b60c9c098798",
        "storage_key": "property/6767906449167749/01a05872-88b7-763f-bb7f-b60c9c098798.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jerseymikes.com/32021/happy-valley-or?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=9897626027915517023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jersey-mikes-subs",
      "poi_latitude": "45.42714",
      "poi_longitude": "-122.488876",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-855-5867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Vn983qelVQRX5yQuW5uW4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_5122c17a-9661-4cbf-a43b-0ac49180cd32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Willamette Valley Vineyards - Happy Valley",
      "poi_type": "Restaurants",
      "poi_address": "13220 SE 172nd Ave STE 160, Happy Valley, OR 97086, USA",
      "poi_short_description": "Willamette Valley Winery tasting room with a Northwest-inspired menu and outdoor seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-86c8-719c-b91c-0c35e3b039bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-86c8-719c-b91c-0c35e3b039bb",
        "storage_key": "property/6767906449167749/01a05872-86c8-719c-b91c-0c35e3b039bb.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.wvv.com/Visit-Us/Happy-Valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=3246117154783945165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willamette-valley-vineyards---happy-valley",
      "poi_latitude": "45.4265057",
      "poi_longitude": "-122.484761",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-427-2430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDcb7UQWflVQRzeEyhlqGDC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_73982153-b7f4-4a13-9941-b2796e59386b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Noodle Man",
      "poi_type": "Restaurants",
      "poi_address": "15888 SE Happy Valley Town Center Dr, Happy Valley, OR 97086, USA",
      "poi_short_description": "Family-friendly eatery serving handmade noodles in broth, plus chow mein and other Chinese dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8084-7420-8118-dc498450a826.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8084-7420-8118-dc498450a826",
        "storage_key": "property/6767906449167749/01a05872-8084-7420-8118-dc498450a826.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.noodlemanhappyvalley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12459159717788127530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noodle-man",
      "poi_latitude": "45.4273745",
      "poi_longitude": "-122.4996956",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-878-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSgrI26elVQRKhGeesDT56w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_1e80dd8d-78f9-4a26-92a5-a692b497f93a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Phở Gabo Happy Valley",
      "poi_type": "Restaurants",
      "poi_address": "9960 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "Casual Vietnamese restaurant known for noodle dishes such as pho and vermicelli, plus fried rice, rolls and salads.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8e55-77a8-b8a9-3b83c4a42b3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8e55-77a8-b8a9-3b83c4a42b3a",
        "storage_key": "property/6767906449167749/01a05872-8e55-77a8-b8a9-3b83c4a42b3a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://phogabo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13339874406202366259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ph-gabo-happy-valley",
      "poi_latitude": "45.4512566",
      "poi_longitude": "-122.5773647",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-694-3955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP7IG1JSflVQRM1kEQhjBILk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5258cfc4-b4ff-480b-b4ca-a6b5af0deded",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Umami Ramen",
      "poi_type": "Restaurants",
      "poi_address": "14638 SE Sunnyside Rd, Happy Valley, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8e18-7510-94ee-ec7b89a18a23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8e18-7510-94ee-ec7b89a18a23",
        "storage_key": "property/6767906449167749/01a05872-8e18-7510-94ee-ec7b89a18a23.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://order.mealkeyway.com/customer/release/index?mid=6f74507543395a5a6359774b5a4673776d35573359673d3d",
      "poi_directions_map_url": "https://maps.google.com/?cid=11759814616892153885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "umami-ramen",
      "poi_latitude": "45.4239115",
      "poi_longitude": "-122.5132391",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-878-4980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wKYRBKelVQRHaBNgBZBM6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_78605c49-3572-4d3f-87d5-b0358cab43f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Happy Hollow",
      "poi_type": "Restaurants",
      "poi_address": "16085 SE Happy Valley Town Center Dr, Happy Valley, OR 97086, USA",
      "poi_short_description": "Laid-back joint for creative wood-fired pies & craft beer, plus happy-hour items.",
      "poi_long_description": "Laid-back joint for creative wood-fired pies & craft beer, plus happy-hour items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8d2e-7432-b0b8-c535021a0115.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8d2e-7432-b0b8-c535021a0115",
        "storage_key": "property/6767906449167749/01a05872-8d2e-7432-b0b8-c535021a0115.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.happyhollowpizza.com/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=d743f836-dce4-465d-aecf-e24b09ddc169",
      "poi_directions_map_url": "https://maps.google.com/?cid=5803717365313781145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "happy-hollow",
      "poi_latitude": "45.4281833",
      "poi_longitude": "-122.4980842",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-427-2961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM8sbzW-elVQRmT1LwDHyilA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_bfda6468-5298-4bf4-ab0d-b6660516b48a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Stickmen Brewing Company - Happy Valley",
      "poi_type": "Restaurants",
      "poi_address": "13100 SE 172nd Ave Ste 106, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8d19-73c1-b52f-3204baedb0f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8d19-73c1-b52f-3204baedb0f4",
        "storage_key": "property/6767906449167749/01a05872-8d19-73c1-b52f-3204baedb0f4.webp",
        "width": 484,
        "height": 640
      },
      "poi_business_url": "http://www.stickmenbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4293855867090737351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stickmen-brewing-company---happy-valley",
      "poi_latitude": "45.4288804",
      "poi_longitude": "-122.4852479",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-342-8451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNVW4qISflVQRx5irSinXljs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ca4b98f7-bb45-457c-b55d-9184766969ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Sushi Moto",
      "poi_type": "Restaurants",
      "poi_address": "15725 SE Happy Valley Town Center Dr, Happy Valley, OR 97015, USA",
      "poi_short_description": "Strip-mall eatery starring a long sushi menu, plus Japanese grill fare & bento-box specials.",
      "poi_long_description": "Strip-mall eatery starring a long sushi menu, plus Japanese grill fare & bento-box specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8f3f-72fa-9102-7187cbc87b8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8f3f-72fa-9102-7187cbc87b8f",
        "storage_key": "property/6767906449167749/01a05872-8f3f-72fa-9102-7187cbc87b8f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.mysushimoto.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13236658992278810234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-moto",
      "poi_latitude": "45.4280006",
      "poi_longitude": "-122.5007109",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-855-4668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnUMDNm6elVQRei7C_zgPsrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_e81f7cdf-580c-4f8e-b2dd-dde931d0c5c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "New Seasons Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "15861 SE Happy Valley Town Center Dr, Happy Valley, OR 97086, USA",
      "poi_short_description": "This grocery supplier with many locally sourced items also sells home goods & wellness products.",
      "poi_long_description": "This grocery supplier with many locally sourced items also sells home goods & wellness products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8e96-734c-9897-5fbe6e590b31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8e96-734c-9897-5fbe6e590b31",
        "storage_key": "property/6767906449167749/01a05872-8e96-734c-9897-5fbe6e590b31.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.newseasonsmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3947867791840582620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-seasons-market",
      "poi_latitude": "45.4283333",
      "poi_longitude": "-122.5",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-558-9214",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1b-73e9-952b-043f0f187e22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1b-73e9-952b-043f0f187e22",
        "storage_key": "property/6767906449167749/01a05870-7b1b-73e9-952b-043f0f187e22.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ZH1oYKglVQR3BvdCNekyTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c56ee67a-e3d4-42a6-82df-29355aae1cc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "17005 SE Sunnyside Rd, Happy Valley, OR 97015, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-8d48-73c0-b260-3a239a52618a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-8d48-73c0-b260-3a239a52618a",
        "storage_key": "property/6767906449167749/01a05872-8d48-73c0-b260-3a239a52618a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/or/happy-valley/fred-meyer/701/00694?cid=loc_70100694_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7817336439917645334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "45.428538",
      "poi_longitude": "-122.4877115",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 971-999-6250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1b-73e9-952b-043f0f187e22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1b-73e9-952b-043f0f187e22",
        "storage_key": "property/6767906449167749/01a05870-7b1b-73e9-952b-043f0f187e22.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwdu23uelVQRFg4C9xLCfGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_837e1e74-e396-4866-a38a-4312c1bbed00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Grocery Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "14800 SE Sunnyside Rd, Happy Valley, OR 97015, USA",
      "poi_short_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_long_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9641-76ec-aff5-8372782494f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9641-76ec-aff5-8372782494f4",
        "storage_key": "property/6767906449167749/01a05872-9641-76ec-aff5-8372782494f4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.groceryoutlet.com/circulars/storeid/323",
      "poi_directions_map_url": "https://maps.google.com/?cid=12395627868591789256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grocery-outlet",
      "poi_latitude": "45.4240725",
      "poi_longitude": "-122.5109073",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-855-3534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1b-73e9-952b-043f0f187e22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1b-73e9-952b-043f0f187e22",
        "storage_key": "property/6767906449167749/01a05870-7b1b-73e9-952b-043f0f187e22.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-SUixKelVQRyJRYI98dBqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f6a32605-4a46-45d1-9937-b269199a4003",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "11995 SE Sunnyside Rd, Happy Valley, OR 97015, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9253-732a-ac45-cce8bc42aa77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9253-732a-ac45-cce8bc42aa77",
        "storage_key": "property/6767906449167749/01a05872-9253-732a-ac45-cce8bc42aa77.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-11995+se+sunnyside+rd-happy+valley-or-97015/id=15927",
      "poi_directions_map_url": "https://maps.google.com/?cid=15982566165861402589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "45.429967",
      "poi_longitude": "-122.5394279",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-653-1526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b4b-7361-a1de-48632e46b12a",
        "storage_key": "property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ29jgDCSelVQR3YdYoz97zd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_aaf396ca-bfb9-4d9b-8435-573a8d80e044",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Happy Valley Ace Hardware",
      "poi_type": "Shopping & Retail",
      "poi_address": "14718 SE Sunnyside Rd, Happy Valley, OR 97015, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-93e3-7208-8068-6f3795b08293.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-93e3-7208-8068-6f3795b08293",
        "storage_key": "property/6767906449167749/01a05872-93e3-7208-8068-6f3795b08293.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.acehardware.com/store-details/15939?utm_source=google&utm_medium=localstore&utm_campaign=",
      "poi_directions_map_url": "https://maps.google.com/?cid=10370633785543701836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "happy-valley-ace-hardware",
      "poi_latitude": "45.4235834",
      "poi_longitude": "-122.5121099",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-563-6665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b48-760c-9afa-cd32f7deac8f",
        "storage_key": "property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5z5SZRKelVQRTDX_Ynvk648",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_348098ae-42cf-4187-ab39-da5c0ec373c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Walmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "10000 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "Superstore stocks groceries, toys, furniture and more, plus offering photo services, electronics and clothes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9302-727d-a03a-5b241de78150.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9302-727d-a03a-5b241de78150",
        "storage_key": "property/6767906449167749/01a05872-9302-727d-a03a-5b241de78150.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5440-happy-valley-or?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11140222711758846668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart",
      "poi_latitude": "45.4501214",
      "poi_longitude": "-122.576183",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-788-4748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b48-760c-9afa-cd32f7deac8f",
        "storage_key": "property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbV5sX9-flVQRzPofbYgFmpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e8061629-053b-4c53-945e-f55ed525f750",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Clackamas Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "12000 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "Chain retailer offering trendy, brand-name clothing & shoes, plus gear for skate- & snowboarders.",
      "poi_long_description": "Chain retailer offering trendy, brand-name clothing & shoes, plus gear for skate- & snowboarders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-4b30-735b-9093-457d76a6541e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-4b30-735b-9093-457d76a6541e",
        "storage_key": "property/6767906449167749/01a05870-4b30-735b-9093-457d76a6541e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.clackamastowncenter.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12922097351639682301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clackamas-town-center",
      "poi_latitude": "45.4360639",
      "poi_longitude": "-122.5728874",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-653-6613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b48-760c-9afa-cd32f7deac8f",
        "storage_key": "property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnyaLa3h1lVQR_cx_vRODVLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_03dfe7b8-0ae7-42a3-bcde-2277bdd34574",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9300 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-4a61-7778-ae15-aa0cc7860b5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-4a61-7778-ae15-aa0cc7860b5a",
        "storage_key": "property/6767906449167749/01a05870-4a61-7778-ae15-aa0cc7860b5a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.homedepot.com/l/Clackamas/OR/Happy-Valley/97086/4040?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3259447857262236735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "45.4557948",
      "poi_longitude": "-122.576422",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-774-6342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b48-760c-9afa-cd32f7deac8f",
        "storage_key": "property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDWAVluCflVQRPxQGkI7iOy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_96e7bd2a-a03f-4a51-81a0-250b33fec9a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "9345 SE 82nd Ave, Clackamas, OR 97086, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-4777-72e9-9c85-67154ecf0d0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-4777-72e9-9c85-67154ecf0d0c",
        "storage_key": "property/6767906449167749/01a05870-4777-72e9-9c85-67154ecf0d0c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/or/clackamas/152/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16829395124031297543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "45.4558588",
      "poi_longitude": "-122.5807379",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-771-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1b-73e9-952b-043f0f187e22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1b-73e9-952b-043f0f187e22",
        "storage_key": "property/6767906449167749/01a05870-7b1b-73e9-952b-043f0f187e22.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9Zo-OCflVQRB5iTCLMFjuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cdf5b53a-60e5-4e6d-9989-f3a08b53a256",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Sunnyside Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "14718 SE Sunnyside Rd #8, Happy Valley, OR 97015, USA",
      "poi_short_description": "Shopping center with an Ace Hardware store and a variety of food options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-93a3-75ea-94c7-7f76c029cce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-93a3-75ea-94c7-7f76c029cce6",
        "storage_key": "property/6767906449167749/01a05872-93a3-75ea-94c7-7f76c029cce6.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15456896197628029094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunnyside-village",
      "poi_latitude": "45.4234989",
      "poi_longitude": "-122.5117186",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b48-760c-9afa-cd32f7deac8f",
        "storage_key": "property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnxXLZhKelVQRpmi0lTLtgdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a201deff-c5fe-4de1-b710-1216b6d67d14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Verne A. Duncan Elementary School",
      "poi_type": "Education",
      "poi_address": "14898 SE Parklane Dr, Happy Valley, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9834-7659-b402-36b63fcb817e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9834-7659-b402-36b63fcb817e",
        "storage_key": "property/6767906449167749/01a05872-9834-7659-b402-36b63fcb817e.webp",
        "width": 1280,
        "height": 450
      },
      "poi_business_url": "https://duncan.nclack.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6140496745352472451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "verne-a-duncan-elementary-school",
      "poi_latitude": "45.415363",
      "poi_longitude": "-122.4873372",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-353-3270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIaDwGUuelVQRgyctk0FtN1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_52b8fd46-7317-4427-969b-82d4773d5915",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Happy Valley Middle School",
      "poi_type": "Education",
      "poi_address": "13865 SE King Rd, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-96ac-704c-97c9-07a2335bab22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-96ac-704c-97c9-07a2335bab22",
        "storage_key": "property/6767906449167749/01a05872-96ac-704c-97c9-07a2335bab22.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://happyvalleyms.nclack.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15347831374157808898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "happy-valley-middle-school",
      "poi_latitude": "45.4475793",
      "poi_longitude": "-122.5184817",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-353-1920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs9JF6k2elVQRAoVFiVFz_tQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_cea2271d-4ff0-4af9-a4c6-5006840852a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Adrienne C. Nelson High School",
      "poi_type": "Education",
      "poi_address": "14897 SE Parklane Dr, Happy Valley, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nclack.k12.or.us/anhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=7333519775706779298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adrienne-c-nelson-high-school",
      "poi_latitude": "45.41548179999999",
      "poi_longitude": "-122.4931815",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-353-5750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK0rDwLidlVQRog5OoGHlxWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_54beebf4-2aa2-48c4-8b82-1b2ff94e68de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Scouters Mountain Elementary",
      "poi_type": "Education",
      "poi_address": "10811 SE 172nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-985f-76d6-bf6d-152c6a1f2842.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-985f-76d6-bf6d-152c6a1f2842",
        "storage_key": "property/6767906449167749/01a05872-985f-76d6-bf6d-152c6a1f2842.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nclack.k12.or.us/scoutersmountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=9393540140873378043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scouters-mountain-elementary",
      "poi_latitude": "45.44358159999999",
      "poi_longitude": "-122.4882396",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-353-3250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMa_IZPSelVQR-2ghMP2OXII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_16e6eaa1-0aba-40b6-8768-42ba6c24bfa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Spring Mountain Elementary",
      "poi_type": "Education",
      "poi_address": "11645 SE Masa Ln, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://springmountain.nclack.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4453454461266340812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-mountain-elementary",
      "poi_latitude": "45.4372894",
      "poi_longitude": "-122.5347954",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-353-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJidfpkTCelVQRzKsoszzZzT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_63034e10-fb22-455a-b883-f12d0c2f9198",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Happy Valley Elementary School",
      "poi_type": "Education",
      "poi_address": "13865 SE King Rd A, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9851-71cb-8a2f-441b393f87c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9851-71cb-8a2f-441b393f87c0",
        "storage_key": "property/6767906449167749/01a05872-9851-71cb-8a2f-441b393f87c0.webp",
        "width": 1280,
        "height": 450
      },
      "poi_business_url": "https://happyvalley.nclack.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13483517637684178046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "happy-valley-elementary-school",
      "poi_latitude": "45.4475524",
      "poi_longitude": "-122.5172475",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-353-5420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXWhrDlKelVQRfizhTNoTH7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_65735d6c-13fd-4457-8bb2-784f5c79798a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Clackamas Middle College",
      "poi_type": "Education",
      "poi_address": "12021 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9979-7334-9cf7-2be638768bcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9979-7334-9cf7-2be638768bcb",
        "storage_key": "property/6767906449167749/01a05872-9979-7334-9cf7-2be638768bcb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.clackamasmiddlecollege.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11281655440713025499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clackamas-middle-college",
      "poi_latitude": "45.4360189",
      "poi_longitude": "-122.5795031",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-518-5925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm_NuQrx1lVQR24cNvtl9kJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5b816a81-752c-4d49-b234-0ee65ed22b8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Happy Valley Montessori School",
      "poi_type": "Education",
      "poi_address": "14543 SE Marci Way, Clackamas, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://happyvalleymontessori.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18286539723056609863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "happy-valley-montessori-school",
      "poi_latitude": "45.4173409",
      "poi_longitude": "-122.5238788",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-698-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxxuclgSelVQRR_rb6_3Wxv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_68739964-53ee-4628-898f-c20d9f447dc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Cadence Academy Preschool",
      "poi_type": "Education",
      "poi_address": "12771 SE Sunnyside Rd, Clackamas, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-99c6-77ba-941d-83d1c3e6cb78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-99c6-77ba-941d-83d1c3e6cb78",
        "storage_key": "property/6767906449167749/01a05872-99c6-77ba-941d-83d1c3e6cb78.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cadence-education.com/locations/or/clackamas/834?utm_source=google&utm_medium=local_listing&utm_campaign=local_seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=16571120087640025856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cadence-academy-preschool",
      "poi_latitude": "45.4277378",
      "poi_longitude": "-122.5323238",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-908-9842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5Vr5liKelVQRAKsfEuxx-OU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_b0837e16-71aa-4f6a-aaa6-0c31e8e22afb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "The Goddard School of Clackamas - Happy Valley",
      "poi_type": "Education",
      "poi_address": "14210 SE Sunnyside Rd Suite 500, Clackamas, OR 97015, USA",
      "poi_short_description": "Pre-K, daycare and infant-care facility offering a range of programs and a social environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9b28-7038-9911-97c5eb69a515.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9b28-7038-9911-97c5eb69a515",
        "storage_key": "property/6767906449167749/01a05872-9b28-7038-9911-97c5eb69a515.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/or/clackamas/clackamas-happy-valley?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=7753674126968645883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-clackamas---happy-valley",
      "poi_latitude": "45.42398900000001",
      "poi_longitude": "-122.51712",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-658-8715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9YDPfBGelVQR-2gaqomVmms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_a851540c-7e67-45a2-952d-eb100b58b24a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Cinemark Clackamas Town Center and XD",
      "poi_type": "Entertainment",
      "poi_address": "12000 SE 82nd Ave, Clackamas, OR 97086, USA",
      "poi_short_description": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks.",
      "poi_long_description": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9c9c-7388-87b0-a6eebb6b4afc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9c9c-7388-87b0-a6eebb6b4afc",
        "storage_key": "property/6767906449167749/01a05872-9c9c-7388-87b0-a6eebb6b4afc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/or-clackamas/cinemark-clackamas-town-center-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&y_source=1_MTc0OTMyMDQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16293821388547881665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-clackamas-town-center-and-xd",
      "poi_latitude": "45.4359591",
      "poi_longitude": "-122.5739637",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-654-1498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c777-7325-85e7-7a0a7c11dcc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05872-c777-7325-85e7-7a0a7c11dcc6",
        "storage_key": "property/6767906449167749/01a05872-c777-7325-85e7-7a0a7c11dcc6.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJUzedVXh1lVQRwfoOejlIH-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b36551b6-4ec7-49fb-8d19-6555433512ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Dave & Buster's Happy Valley - Clackamas",
      "poi_type": "Restaurants",
      "poi_address": "11860 SE 82nd Ave #4020, Happy Valley, OR 97086, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9cd8-70fc-a0dd-8a9041fdf626.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9cd8-70fc-a0dd-8a9041fdf626",
        "storage_key": "property/6767906449167749/01a05872-9cd8-70fc-a0dd-8a9041fdf626.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/happy-valley-clackamas",
      "poi_directions_map_url": "https://maps.google.com/?cid=10294260261211443643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-happy-valley---clackamas",
      "poi_latitude": "45.4348212",
      "poi_longitude": "-122.5751918",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-305-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1c-77ac-bb35-dd389f17736a",
        "storage_key": "property/6767906449167749/01a05870-7b1c-77ac-bb35-dd389f17736a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJma7qHXh1lVQRu5HtjiqP3I4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_431c871e-2547-4ab7-99ad-f4ed3f6b4075",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Play Street Museum - Happy Valley",
      "poi_type": "Entertainment",
      "poi_address": "13120 SE 172nd Ave Ste 116, Happy Valley, OR 97086, USA",
      "poi_short_description": "Cozy indoor playground with themed play areas, toys, painting and slime-making activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-5a85-71be-a5f5-f964b9ddc431.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-5a85-71be-a5f5-f964b9ddc431",
        "storage_key": "property/6767906449167749/01a05870-5a85-71be-a5f5-f964b9ddc431.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.happyvalley.playstreetmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17232434653513804753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "play-street-museum---happy-valley",
      "poi_latitude": "45.428519",
      "poi_longitude": "-122.485262",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-963-6359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1d-70dc-bfad-25662ba73806.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1d-70dc-bfad-25662ba73806",
        "storage_key": "property/6767906449167749/01a05870-7b1d-70dc-bfad-25662ba73806.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmyGwxlaflVQR0WvSGQToJe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e5c89e91-d2a4-43b5-b46b-c8736aaa7687",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Historic Oregon City",
      "poi_type": "Entertainment",
      "poi_address": "1726 Washington St, Oregon City, OR 97045, USA",
      "poi_short_description": "Interpretive center with costumed guides & interactive exhibits showcasing life in the mid-1800s.",
      "poi_long_description": "Interpretive center with costumed guides & interactive exhibits showcasing life in the mid-1800s.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-5042-779d-8a6f-5df1b058e583.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-5042-779d-8a6f-5df1b058e583",
        "storage_key": "property/6767906449167749/01a05870-5042-779d-8a6f-5df1b058e583.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.historicoregoncity.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6925041589528183897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-oregon-city",
      "poi_latitude": "45.3652026",
      "poi_longitude": "-122.5943702",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-657-9336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1d-70dc-bfad-25662ba73806.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1d-70dc-bfad-25662ba73806",
        "storage_key": "property/6767906449167749/01a05870-7b1d-70dc-bfad-25662ba73806.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJKzRsH6OglVQRWUSinqKwGmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_20fc3d0e-eb55-47b5-a139-dcb254b95c0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Regal Hilltop",
      "poi_type": "Entertainment",
      "poi_address": "325 S Beavercreek Rd, Oregon City, OR 97045, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9f40-77c0-a7dd-7720d0d393bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9f40-77c0-a7dd-7720d0d393bd",
        "storage_key": "property/6767906449167749/01a05872-9f40-77c0-a7dd-7720d0d393bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-hilltop-cinema-0853?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9419147868835205131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-hilltop",
      "poi_latitude": "45.33449",
      "poi_longitude": "-122.593155",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c777-7325-85e7-7a0a7c11dcc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05872-c777-7325-85e7-7a0a7c11dcc6",
        "storage_key": "property/6767906449167749/01a05872-c777-7325-85e7-7a0a7c11dcc6.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ081bK8VwlVQRC9DM-BSJt4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_df82f1ee-2b83-4886-8379-74fb0113c34a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "OMSI",
      "poi_type": "Entertainment",
      "poi_address": "1945 SE Water Ave, Portland, OR 97214, USA",
      "poi_short_description": "Rotating shows, science labs, submarine tours & planetarium at a museum with monthly 21+ events.",
      "poi_long_description": "Rotating shows, science labs, submarine tours & planetarium at a museum with monthly 21+ events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9d8d-7768-a902-3c3c0ac1a5df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9d8d-7768-a902-3c3c0ac1a5df",
        "storage_key": "property/6767906449167749/01a05872-9d8d-7768-a902-3c3c0ac1a5df.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://omsi.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15020746415816767564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "omsi",
      "poi_latitude": "45.5083931",
      "poi_longitude": "-122.6660355",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 503-797-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1d-70dc-bfad-25662ba73806.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1d-70dc-bfad-25662ba73806",
        "storage_key": "property/6767906449167749/01a05870-7b1d-70dc-bfad-25662ba73806.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RKx6HIKlVQRTPj6J0hpdNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6e8e0b3c-3250-4663-9f92-e006c97d649e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Oregon Rail Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "2250 SE Water Ave, Portland, OR 97214, USA",
      "poi_short_description": "Indoor museum housing historic exhibits & multiple restored trains, some of which are operational.",
      "poi_long_description": "Indoor museum housing historic exhibits & multiple restored trains, some of which are operational.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-9faa-715f-8af8-b175ab3f5ebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-9faa-715f-8af8-b175ab3f5ebd",
        "storage_key": "property/6767906449167749/01a05872-9faa-715f-8af8-b175ab3f5ebd.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.orhf.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3408009002404238373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oregon-rail-heritage-center",
      "poi_latitude": "45.50717100000001",
      "poi_longitude": "-122.661776",
      "poi_miles_from_property": "13.3",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 503-233-1156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b1d-70dc-bfad-25662ba73806.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b1d-70dc-bfad-25662ba73806",
        "storage_key": "property/6767906449167749/01a05870-7b1d-70dc-bfad-25662ba73806.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3L603MKlVQRJVSjmyGuSy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9925c7c4-001e-41b5-a4b3-8569bbc0510e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Happy Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13770 SE Ridgecrest Rd, Happy Valley, OR 97086, USA",
      "poi_short_description": "Summer concerts lure locals to this green locale boasting multiple picnic shelters & sports spaces.",
      "poi_long_description": "Summer concerts lure locals to this green locale boasting multiple picnic shelters & sports spaces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-6616-771e-9ac5-8b59ad4c7516.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-6616-771e-9ac5-8b59ad4c7516",
        "storage_key": "property/6767906449167749/01a05870-6616-771e-9ac5-8b59ad4c7516.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.happyvalleyor.gov/?NID=143",
      "poi_directions_map_url": "https://maps.google.com/?cid=2162196277840598281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "happy-valley-park",
      "poi_latitude": "45.4518711",
      "poi_longitude": "-122.5214409",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-783-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b3c-74db-959b-7ca83514c5d4",
        "storage_key": "property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_wLqzSelVQRCVVcEw-qAR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_82d64b01-bf58-42ae-9768-e887f7270aea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Powell's City of Books",
      "poi_type": "Shopping & Retail",
      "poi_address": "1005 W Burnside St, Portland, OR 97209, USA",
      "poi_short_description": "Iconic bookseller offering a diverse selection of used & new volumes, plus gifts for bibliophiles.",
      "poi_long_description": "Iconic bookseller offering a diverse selection of used & new volumes, plus gifts for bibliophiles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-a32e-727f-b67c-f1276b7099b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-a32e-727f-b67c-f1276b7099b6",
        "storage_key": "property/6767906449167749/01a05872-a32e-727f-b67c-f1276b7099b6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.powells.com/locations/powells-city-of-books",
      "poi_directions_map_url": "https://maps.google.com/?cid=6978470595407941935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "powells-city-of-books",
      "poi_latitude": "45.5232451",
      "poi_longitude": "-122.6814329",
      "poi_miles_from_property": "15.1",
      "poi_walking_minutes": "5 hours 33 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 800-878-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b48-760c-9afa-cd32f7deac8f",
        "storage_key": "property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJByq0twMKlVQRL5HMcgiC2GA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_e512bc36-e3f5-4480-8105-efd35348d1b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Providence Willamette Falls Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 Division St, Oregon City, OR 97045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-a275-76d8-a46d-9407df47f2c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-a275-76d8-a46d-9407df47f2c2",
        "storage_key": "property/6767906449167749/01a05872-a275-76d8-a46d-9407df47f2c2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.providence.org/locations/or/willamette-falls-medical-center?Is=location&y_source=1_OTU3NjI1MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ==",
      "poi_directions_map_url": "https://maps.google.com/?cid=10057798318154886478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-willamette-falls-medical-center",
      "poi_latitude": "45.3561465",
      "poi_longitude": "-122.587139",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-656-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b29-73e9-8e30-0dbd88eb4c36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b29-73e9-8e30-0dbd88eb4c36",
        "storage_key": "property/6767906449167749/01a05870-7b29-73e9-8e30-0dbd88eb4c36.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJd1hyMNB2lVQRTq0kKEh6lIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_92d99ed7-7ed9-445d-94af-de6d9b33946a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Providence Urgent Care - Happy Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "16180 SE Sunnyside Rd #102, Happy Valley, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-a403-73dc-a69d-acf19b24bae9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-a403-73dc-a69d-acf19b24bae9",
        "storage_key": "property/6767906449167749/01a05872-a403-73dc-a69d-acf19b24bae9.webp",
        "width": 600,
        "height": 600
      },
      "poi_business_url": "https://www.providence.org/locations/urgent-care/or/urgent-care-happy-valley?Is=location&y_source=1_OTU3NjEyMC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8196877727647707834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-urgent-care---happy-valley",
      "poi_latitude": "45.4266161",
      "poi_longitude": "-122.4974427",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-582-4975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b4b-7361-a1de-48632e46b12a",
        "storage_key": "property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrSDZznGelVQRurLAR90owXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_076c5a72-642d-4c36-aeff-aa97fb6ba18c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Legacy-GoHealth Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "9361 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-a4d5-7552-896d-ffe4b0c83957.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-a4d5-7552-896d-ffe4b0c83957",
        "storage_key": "property/6767906449167749/01a05872-a4d5-7552-896d-ffe4b0c83957.webp",
        "width": 685,
        "height": 345
      },
      "poi_business_url": "https://www.gohealthuc.com/legacy/locations/johnson-creek?utm_source=gmb&utm_medium=organic&utm_content=legacy-johnsoncreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=5046624019087544350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-gohealth-urgent-care",
      "poi_latitude": "45.4554754",
      "poi_longitude": "-122.5797818",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 971-202-2090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b4b-7361-a1de-48632e46b12a",
        "storage_key": "property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUVOwXuCflVQRHtCqpM41CUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_433ac8e6-a346-496c-9c1a-27bc24f17828",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "ZoomCare Happy Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "17155 SE Sunnyside Rd Suite 160, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.zoomcare.com/clinic/zoomcare-happy-valley?utm_campaign=gmb-site&utm_source=google&utm_medium=maps&utm_content=happy-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=1098467928291860475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zoomcare-happy-valley",
      "poi_latitude": "45.42677219999999",
      "poi_longitude": "-122.4862491",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 844-966-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b4b-7361-a1de-48632e46b12a",
        "storage_key": "property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1_jBDgCflVQR-9_-xsKKPg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_9f9d7d34-7903-42ba-a833-71e2e613bf38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Fred Meyer Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "17005 SE Sunnyside Rd, Happy Valley, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-a6cc-7018-bbf5-1bdfa182869b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-a6cc-7018-bbf5-1bdfa182869b",
        "storage_key": "property/6767906449167749/01a05872-a6cc-7018-bbf5-1bdfa182869b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fredmeyer.com/rx/pharmacy/details/701/00694?cid=loc_70100694P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5770314629722368026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer-pharmacy",
      "poi_latitude": "45.4284623",
      "poi_longitude": "-122.4876669",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 971-999-6284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c779-7637-acad-65964d9f1542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05872-c779-7637-acad-65964d9f1542",
        "storage_key": "property/6767906449167749/01a05872-c779-7637-acad-65964d9f1542.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4NPbXuelVQRGmjXUpVGFFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a47ceeb1-8651-4138-99ec-966347d31ff9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9000 SE Sunnyside Rd, Clackamas, OR 97015, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-a57b-70f8-8c12-92f3302f462f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-a57b-70f8-8c12-92f3302f462f",
        "storage_key": "property/6767906449167749/01a05872-a57b-70f8-8c12-92f3302f462f.webp",
        "width": 1067,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/clackamas-or-pharmacies/9000-se-sunnyside-rd-clackamas-or-97015/storeid=16127?WT.mc_id=LS_GOOGLE_RX_16127",
      "poi_directions_map_url": "https://maps.google.com/?cid=3008595771936455644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "45.43169839999999",
      "poi_longitude": "-122.5701125",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-974-5058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c779-7637-acad-65964d9f1542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05872-c779-7637-acad-65964d9f1542",
        "storage_key": "property/6767906449167749/01a05872-c779-7637-acad-65964d9f1542.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6pY2YJ1lVQR3LsDE-qtwCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6242414e-e18e-478d-a74a-fde650238438",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Snap Fitness Happy Valley (Sunnyside)",
      "poi_type": "Health and Wellness",
      "poi_address": "14800 SE Sunnyside Rd Ste B, Happy Valley, OR 97015, USA",
      "poi_short_description": "Relaxed spot offering 24/7 access to clean workout facilities and equipment, including weight machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-ad6c-7309-9eef-fb661b10d35b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-ad6c-7309-9eef-fb661b10d35b",
        "storage_key": "property/6767906449167749/01a05872-ad6c-7309-9eef-fb661b10d35b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.snapfitness.com/us/gyms/happy-valley-sunnyside-or/?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=9869486319113397780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snap-fitness-happy-valley-sunnyside",
      "poi_latitude": "45.4238284",
      "poi_longitude": "-122.5110954",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-427-2569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b4b-7361-a1de-48632e46b12a",
        "storage_key": "property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3Ujsi-flVQRFOZUNoR194g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2bd8ab8a-51bb-409e-804b-8918204126a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "12900 SE 162nd Ave Ste. 101, Happy Valley, OR 97086, USA",
      "poi_short_description": "A Pilates studio featuring beginner-friendly, challenging workouts (some on Reformer machines), plus friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-aaa2-744f-bcd6-01cc1dd5cdf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-aaa2-744f-bcd6-01cc1dd5cdf0",
        "storage_key": "property/6767906449167749/01a05872-aaa2-744f-bcd6-01cc1dd5cdf0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.clubpilates.com/happyvalley/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=4945055833948728587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "45.4290853",
      "poi_longitude": "-122.4963493",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 971-236-7634",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_-_28m-elVQRC638uBReoEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e82692a0-3382-4c75-98b9-ce72c13e70a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "16126 SE Happy Valley Town Center Dr Ste 201, Happy Valley, OR 97086, USA",
      "poi_short_description": "Fitness studio offering group classes using treadmills, strength training and heart-rate monitors.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-ad47-75b9-846f-049bf7261c5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-ad47-75b9-846f-049bf7261c5e",
        "storage_key": "property/6767906449167749/01a05872-ad47-75b9-846f-049bf7261c5e.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/happy-valley-oregon-0510?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=8466825123739759037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "45.4275557",
      "poi_longitude": "-122.4981323",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-882-0087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b4b-7361-a1de-48632e46b12a",
        "storage_key": "property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFexeF_yflVQRvXHcQ5c0gHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a82b9cb7-e4c5-4ba8-8b11-61ed38540b2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Scouters Mountain Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11000 SE Honorable Wy, Happy Valley, OR 97086, USA",
      "poi_short_description": "Wooded park with a volcano, offering trails for hiking and picnics, plus views of Mount Hood.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-a900-70cb-998c-17a8cb0fac1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-a900-70cb-998c-17a8cb0fac1f",
        "storage_key": "property/6767906449167749/01a05872-a900-70cb-998c-17a8cb0fac1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oregonmetro.gov/places/scouters-mountain-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6258350754569672914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scouters-mountain-nature-park",
      "poi_latitude": "45.4468894",
      "poi_longitude": "-122.5079772",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-665-4995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b3c-74db-959b-7ca83514c5d4",
        "storage_key": "property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4d7tleelVQR0ljsZdog2lY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9b3ebb73-89b1-4c50-bb2c-0a8e77c2ddd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Mount Talbert Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10945 SE Mather Rd, Clackamas, OR 97015, USA",
      "poi_short_description": "Tree-covered 4-mile trail network ranging from paved, ADA-accessible routes to steep footpaths.",
      "poi_long_description": "Tree-covered 4-mile trail network ranging from paved, ADA-accessible routes to steep footpaths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-aab2-7601-a421-7f3019b58be6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-aab2-7601-a421-7f3019b58be6",
        "storage_key": "property/6767906449167749/01a05872-aab2-7601-a421-7f3019b58be6.webp",
        "width": 1280,
        "height": 947
      },
      "poi_business_url": "http://www.oregonmetro.gov/parks/mount-talbert-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17945920931564547998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mount-talbert-nature-park",
      "poi_latitude": "45.4205094",
      "poi_longitude": "-122.5524356",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-797-1545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b3c-74db-959b-7ca83514c5d4",
        "storage_key": "property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDXezPol1lVQRnu8mdQG4DPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_92b1e9dd-9fd3-43f6-b12c-fa3c2ef40ac2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Village Green Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13786 SE Sieben Park Way, Clackamas, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-aa49-766a-8431-29598aa1a674.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-aa49-766a-8431-29598aa1a674",
        "storage_key": "property/6767906449167749/01a05872-aa49-766a-8431-29598aa1a674.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17368142124451115761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-green-park",
      "poi_latitude": "45.42222049999999",
      "poi_longitude": "-122.5122344",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b3c-74db-959b-7ca83514c5d4",
        "storage_key": "property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____8A2elVQR8TJo6D0JCPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0c482d56-6caa-4210-bc63-a1fd57eb240c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Hood View Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16223 SE Stadium Way, Happy Valley, OR 97015, USA",
      "poi_short_description": "This 35-acre facility for multiple sports also offers picnic tables, walking paths & scenic views.",
      "poi_long_description": "This 35-acre facility for multiple sports also offers picnic tables, walking paths & scenic views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-aef6-77ef-a148-ddf813ea7b9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-aef6-77ef-a148-ddf813ea7b9a",
        "storage_key": "property/6767906449167749/01a05872-aef6-77ef-a148-ddf813ea7b9a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1994716243449903986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hood-view-park",
      "poi_latitude": "45.4176158",
      "poi_longitude": "-122.4945339",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-794-3877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b3c-74db-959b-7ca83514c5d4",
        "storage_key": "property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYoTfN-dlVQRcnuI3tqnrhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e6442110-84c5-4d78-90dc-dd091c4c8fe9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Ashley Meadows Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15410 SE Oregon Trail Dr, Clackamas, OR 97015, USA",
      "poi_short_description": "Red-named, tranquil neighborhood park with a play area, swings and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-b02b-72ef-bfbc-33b38e9c9a54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-b02b-72ef-bfbc-33b38e9c9a54",
        "storage_key": "property/6767906449167749/01a05872-b02b-72ef-bfbc-33b38e9c9a54.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.happyvalleyor.gov/services/parks-and-recreation-2/neighborhood-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17548086637007887890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ashley-meadows-park",
      "poi_latitude": "45.42274",
      "poi_longitude": "-122.5044328",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-742-4348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b3c-74db-959b-7ca83514c5d4",
        "storage_key": "property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_hT1nKelVQREl6iltJTh_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_df1a694e-ad43-4e60-aa79-d892be31d6dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Rebstock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12915 SE King Rd, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-b0db-7199-94f3-012339b4993f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-b0db-7199-94f3-012339b4993f",
        "storage_key": "property/6767906449167749/01a05872-b0db-7199-94f3-012339b4993f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.happyvalleyor.gov/services/parks-and-recreation-2/neighborhood-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13374254341925228765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rebstock-park",
      "poi_latitude": "45.4472326",
      "poi_longitude": "-122.5299836",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-783-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b3c-74db-959b-7ca83514c5d4",
        "storage_key": "property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0FtR0uelVQR3dAt0nblmrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ef9a6fce-8534-40ba-9c96-ab46e94d1159",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Southern Lites Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12088 SE 117th Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "Creek-side neighborhood park (no longer with a playground) featuring a basketball court, a short trail and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-b2f6-708b-b45a-6dba76a40996.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-b2f6-708b-b45a-6dba76a40996",
        "storage_key": "property/6767906449167749/01a05872-b2f6-708b-b45a-6dba76a40996.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17544230001014515725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-lites-park",
      "poi_latitude": "45.4348918",
      "poi_longitude": "-122.5420585",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b3c-74db-959b-7ca83514c5d4",
        "storage_key": "property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMVGhoi-elVQRDag4jDugefM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4204bf01-74fa-4f32-b4cc-6ccaef7c1409",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Powell Butte Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16160 SE Powell Blvd, Portland, OR 97236, USA",
      "poi_short_description": "Family-friendly natural area with plenty of hiking, biking & equestrian trails among scenic vistas.",
      "poi_long_description": "Family-friendly natural area with plenty of hiking, biking & equestrian trails among scenic vistas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-62b1-752d-a328-6a9496902b42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-62b1-752d-a328-6a9496902b42",
        "storage_key": "property/6767906449167749/01a05870-62b1-752d-a328-6a9496902b42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portlandoregon.gov/parks/finder/index.cfm?action=ViewPark&PropertyID=528",
      "poi_directions_map_url": "https://maps.google.com/?cid=11785825895941029343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "powell-butte-nature-park",
      "poi_latitude": "45.4906961",
      "poi_longitude": "-122.4969916",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b3c-74db-959b-7ca83514c5d4",
        "storage_key": "property/6767906449167749/01a05870-7b3c-74db-959b-7ca83514c5d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEd07m0SflVQR3z0qWDWqj6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ad8acf27-6a3b-4923-bd06-954690380307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "SE Fuller Rd Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9716 SE Fuller Rd, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1532230577112607332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "se-fuller-rd-park--ride",
      "poi_latitude": "45.4532945",
      "poi_longitude": "-122.5753403",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 888-275-6368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c777-7325-85e7-77ba84edb268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05872-c777-7325-85e7-77ba84edb268",
        "storage_key": "property/6767906449167749/01a05872-c777-7325-85e7-77ba84edb268.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1gnTN6flVQRZOrJfpeTQxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_7a0673e6-fc90-42a3-91ae-a7110e08e9df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Clackamas Town Center Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Oregon 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-b3a5-756b-a890-67bbe2e785c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-b3a5-756b-a890-67bbe2e785c0",
        "storage_key": "property/6767906449167749/01a05872-b3a5-756b-a890-67bbe2e785c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13619468900177926886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clackamas-town-center-transit-center",
      "poi_latitude": "45.435666",
      "poi_longitude": "-122.568707",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c778-769a-a16a-cd4d5a73de56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05872-c778-769a-a16a-cd4d5a73de56",
        "storage_key": "property/6767906449167749/01a05872-c778-769a-a16a-cd4d5a73de56.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4jSDYJ1lVQR5tqVQM4SAr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_105662fc-18bd-4e08-8379-9556a83fc7d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Tacoma / Johnson Creek MAX Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "SE Clatsop St, Portland, OR 97202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-bbb7-74e9-8d2b-02d7aa035aaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-bbb7-74e9-8d2b-02d7aa035aaa",
        "storage_key": "property/6767906449167749/01a05872-bbb7-74e9-8d2b-02d7aa035aaa.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://trimet.org/parkandride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7850956909669864825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacoma--johnson-creek-max-park--ride",
      "poi_latitude": "45.4620496",
      "poi_longitude": "-122.6379749",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c777-7325-85e7-77ba84edb268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05872-c777-7325-85e7-77ba84edb268",
        "storage_key": "property/6767906449167749/01a05872-c777-7325-85e7-77ba84edb268.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWImqc4KlVQReVXFk7Yz9Gw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_749c7f45-f0fc-4dda-b2ed-97bb66e30f36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Trek Bicycle Happy Valley",
      "poi_type": "Shopping & Retail",
      "poi_address": "9347 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-b52e-73e0-9f89-beb359133457.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-b52e-73e0-9f89-beb359133457",
        "storage_key": "property/6767906449167749/01a05872-b52e-73e0-9f89-beb359133457.webp",
        "width": 640,
        "height": 481
      },
      "poi_business_url": "https://www.trekbikes.com/us/en_US/retail/happy_valley/?y_source=1_MjI1NTk2OTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6254731626346347856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trek-bicycle-happy-valley",
      "poi_latitude": "45.4557722",
      "poi_longitude": "-122.5805661",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-254-2663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b48-760c-9afa-cd32f7deac8f",
        "storage_key": "property/6767906449167749/01a05870-7b48-760c-9afa-cd32f7deac8f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKUaVncehlVQRUH3GcUZFzVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bicycle_store"
    },
    {
      "id": "custom_45de686e-fda3-4cbf-a2f1-364f696d2317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Portland International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7000 NE Airport Way, Portland, OR 97218, USA",
      "poi_short_description": "Hub featuring direct rail service to Downtown, plus works by regional artists & frequent live music.",
      "poi_long_description": "Hub featuring direct rail service to Downtown, plus works by regional artists & frequent live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-b471-734f-b363-0241c3a6955e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-b471-734f-b363-0241c3a6955e",
        "storage_key": "property/6767906449167749/01a05872-b471-734f-b363-0241c3a6955e.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://www.flypdx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6618732977047100477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portland-international-airport",
      "poi_latitude": "45.5852698",
      "poi_longitude": "-122.5917184",
      "poi_miles_from_property": "15.7",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 503-460-4234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c781-737d-999e-ad2168e0068c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05872-c781-737d-999e-ad2168e0068c",
        "storage_key": "property/6767906449167749/01a05872-c781-737d-999e-ad2168e0068c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SDcdKqglVQRPVwOOJN22ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_90eabec9-f889-405c-a8ef-8c6cfaf44049",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Gateway - NE 99th Ave TC Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1249 NE 99th Ave, Portland, OR 97220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-b74a-720e-a681-5f9966ce5b6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-b74a-720e-a681-5f9966ce5b6b",
        "storage_key": "property/6767906449167749/01a05872-b74a-720e-a681-5f9966ce5b6b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://trimet.org/parkandride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9870299602871905209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gateway---ne-99th-ave-tc-park--ride",
      "poi_latitude": "45.53144469999999",
      "poi_longitude": "-122.5626915",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 503-238-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c777-7325-85e7-77ba84edb268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05872-c777-7325-85e7-77ba84edb268",
        "storage_key": "property/6767906449167749/01a05872-c777-7325-85e7-77ba84edb268.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36G9Am6hlVQRuevblzFZ-og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_0660d881-29ad-4597-874b-6f3d6fd94c08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "SE Main St Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1119 SE 96th Ave, Portland, OR 97216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-b869-7268-b1c8-2b414bd3119d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-b869-7268-b1c8-2b414bd3119d",
        "storage_key": "property/6767906449167749/01a05872-b869-7268-b1c8-2b414bd3119d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trimet.org/parkandride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16206052203603230692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "se-main-st-park--ride",
      "poi_latitude": "45.5137671",
      "poi_longitude": "-122.5647851",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c777-7325-85e7-77ba84edb268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05872-c777-7325-85e7-77ba84edb268",
        "storage_key": "property/6767906449167749/01a05872-c777-7325-85e7-77ba84edb268.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJv37vtKWhlVQR5P80p5125-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_85653569-37cc-4bc2-a879-55e93a01e036",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Kaiser Permanente Sunnyside Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10180 SE Sunnyside Rd, Clackamas, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-6253-762c-8ec5-32e96031e595.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-6253-762c-8ec5-32e96031e595",
        "storage_key": "property/6767906449167749/01a05870-6253-762c-8ec5-32e96031e595.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/oregon-washington/facilities/Kaiser-Permanente-Sunnyside-Medical-Center-100249",
      "poi_directions_map_url": "https://maps.google.com/?cid=10088258469650416852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaiser-permanente-sunnyside-medical-center",
      "poi_latitude": "45.4314111",
      "poi_longitude": "-122.5602391",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-813-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b29-73e9-8e30-0dbd88eb4c36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b29-73e9-8e30-0dbd88eb4c36",
        "storage_key": "property/6767906449167749/01a05870-7b29-73e9-8e30-0dbd88eb4c36.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXUrKgYZ1lVQR1MTW1aCxAIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_4fce72ba-2ac5-4448-a65b-e8e0c623cebd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Providence Milwaukie Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "10150 SE 32nd Ave, Milwaukie, OR 97222, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-b920-752d-94a0-920e17008f39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-b920-752d-94a0-920e17008f39",
        "storage_key": "property/6767906449167749/01a05872-b920-752d-94a0-920e17008f39.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.providence.org/locations/or/milwaukie-hospital?ls=location&y_source=1_OTU3NjIxNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1102627407206621211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-milwaukie-hospital",
      "poi_latitude": "45.4494002",
      "poi_longitude": "-122.6275427",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-513-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b29-73e9-8e30-0dbd88eb4c36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b29-73e9-8e30-0dbd88eb4c36",
        "storage_key": "property/6767906449167749/01a05870-7b29-73e9-8e30-0dbd88eb4c36.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdSdhDzB1lVQRGyAp7shRTQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_8e7ba492-fc46-465f-ab12-fbbb7b825911",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Clackamas Community College",
      "poi_type": "Education",
      "poi_address": "19600 Molalla Ave, Oregon City, OR 97045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-be67-765f-a330-304e0e0dde47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-be67-765f-a330-304e0e0dde47",
        "storage_key": "property/6767906449167749/01a05872-be67-765f-a330-304e0e0dde47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.clackamas.edu/student-life/campuses-buildings-hours/oregon-city-campus?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile&utm_content=oregon_city_campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=86912118333098868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clackamas-community-college",
      "poi_latitude": "45.3224837",
      "poi_longitude": "-122.5748049",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 503-594-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJweC1UzlxlVQRdMvrcxzGNAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3654e479-b66e-48c4-85e2-9f1b0d94a8e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "North Clackamas Schools Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12400 SE Freeman Way, Milwaukie, OR 97222, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-bc16-764f-bb0b-9b9aef44eb2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-bc16-764f-bb0b-9b9aef44eb2a",
        "storage_key": "property/6767906449167749/01a05872-bc16-764f-bb0b-9b9aef44eb2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nclack.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2236858348988394044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-clackamas-schools-administration-building",
      "poi_latitude": "45.4332701",
      "poi_longitude": "-122.6162903",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-353-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b2a-75d6-8595-ba767be036ad",
        "storage_key": "property/6767906449167749/01a05870-7b2a-75d6-8595-ba767be036ad.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-y5NVLt1lVQRPOpRKNHqCh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_095c32fc-bc72-41b9-b8a8-eaf58a8fe9eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Clackamas County Public Services Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2051 Kaen Rd, Oregon City, OR 97045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-bcbb-734e-8c79-abfdd58713e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-bcbb-734e-8c79-abfdd58713e0",
        "storage_key": "property/6767906449167749/01a05872-bcbb-734e-8c79-abfdd58713e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.clackamas.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3996336915516034367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clackamas-county-public-services-building",
      "poi_latitude": "45.332817",
      "poi_longitude": "-122.5987548",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7dca-71eb-9a22-3cf8c21d25d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7dca-71eb-9a22-3cf8c21d25d6",
        "storage_key": "property/6767906449167749/01a05870-7dca-71eb-9a22-3cf8c21d25d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2yP-pdxwlVQRPw0dTEDXdTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_5e404195-89bd-43d8-8503-d64e861b9b46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "Happy Valley City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "16000 SE Misty Dr, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7389-71f9-9324-bd79d11ebecb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-7389-71f9-9324-bd79d11ebecb",
        "storage_key": "property/6767906449167749/01a05870-7389-71f9-9324-bd79d11ebecb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.happyvalleyor.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16097911516973870240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "happy-valley-city-hall",
      "poi_latitude": "45.4294153",
      "poi_longitude": "-122.4974471",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-783-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7dca-71eb-9a22-3cf8c21d25d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7dca-71eb-9a22-3cf8c21d25d6",
        "storage_key": "property/6767906449167749/01a05870-7dca-71eb-9a22-3cf8c21d25d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ91JVl2-elVQRoKzl-jtFZ98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_53d6f749-6786-4a62-a927-ec96cd55ae4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "National Guard Recruiting at Camp Withycombe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15300 SE Industrial Way, Happy Valley, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c02e-7745-9ae5-792a452e1c78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-c02e-7745-9ae5-792a452e1c78",
        "storage_key": "property/6767906449167749/01a05872-c02e-7745-9ae5-792a452e1c78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4246768980042076007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-guard-recruiting-at-camp-withycombe",
      "poi_latitude": "45.41247",
      "poi_longitude": "-122.561324",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-580-5501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7dca-71eb-9a22-3cf8c21d25d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7dca-71eb-9a22-3cf8c21d25d6",
        "storage_key": "property/6767906449167749/01a05870-7dca-71eb-9a22-3cf8c21d25d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQcw-Gul1lVQRZ0-OEuON7zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_c37be61e-c486-44c5-935d-a5886c12b762",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "custom",
      "poi_name": "The Springs at Happy Valley",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13160 SE 172nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05872-c26e-72e0-9f88-b5a5274a57da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05872-c26e-72e0-9f88-b5a5274a57da",
        "storage_key": "property/6767906449167749/01a05872-c26e-72e0-9f88-b5a5274a57da.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thespringsliving.com/senior-living/or/happy-valley/se-172nd-avenue/?utm_source=GBP&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=10183014445457973242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-springs-at-happy-valley",
      "poi_latitude": "45.4277787",
      "poi_longitude": "-122.4842914",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-658-8484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05870-7b4b-7361-a1de-48632e46b12a",
        "storage_key": "property/6767906449167749/01a05870-7b4b-7361-a1de-48632e46b12a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv40ceIKflVQR-p8xrK9VUY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8f54eab96283a8cce0aceeb7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_69e0b20eb396963350c237ba",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c7c3e848f5dc9b9ca90073a8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_45065f87f2e03fc1893be0fa",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_13c9f08c3ad22383abb089c6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e6caf297fcec6d50bcf180b8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_a1d7c8d81d1b3e70d8187c45",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "rating": "5",
      "name": "Michael Ephrem",
      "text": "I recently moved in the heights in happy valley and I really love my new apartment and the leasing agent Hannah is absolutely amazing helping by going above and beyond to make the entire process easy and simple for me if I was able to give more stars I would and  highly recommend to give them a chance I’m glad I did",
      "date": "2026-06-04",
      "title": "false"
    },
    {
      "id": "ec_9b5a6bfa14e8b4d208807da5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "rating": "5",
      "name": "B",
      "text": "Hannah did an excellent job of showing us the property and describing all of the amenities. The property is lovely and we look forward to seeing how the property will evolve as they finish their final phases.",
      "date": "2026-07-10",
      "title": "false"
    },
    {
      "id": "ec_fce5445e6e7514e0e8144dae",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "rating": "5",
      "name": "Rick Gonzales",
      "text": "Fast and great experience and very polite.\nWent over to make sure it was fixed.\nThank you.",
      "date": "2026-08-02",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_d29ee273df196e8dc9b84f3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-69b1-70eb-a43e-32c2774574fa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a05870-69b1-70eb-a43e-32c2774574fa",
        "storage_key": "property/6767906449167749/01a05870-69b1-70eb-a43e-32c2774574fa.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Heights Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cBtxqHFWDCa"
    },
    {
      "id": "ec_ceb4f339faec3a47a61cc4b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-68d0-71f9-8288-b11face3f167.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a05870-68d0-71f9-8288-b11face3f167",
        "storage_key": "property/6767906449167749/01a05870-68d0-71f9-8288-b11face3f167.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Heights 1 Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3V8JRbAh7kS"
    },
    {
      "id": "ec_c54f49e4fe6e213740ac4747",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-6b42-70da-9a89-fcc13d4427cf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a05870-6b42-70da-9a89-fcc13d4427cf",
        "storage_key": "property/6767906449167749/01a05870-6b42-70da-9a89-fcc13d4427cf.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Heights 2x2 Model",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CyF4ffQveo8"
    },
    {
      "id": "ec_b44060c75da2bc718337e2ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05870-7592-713e-ba1a-98dcfa26c88a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a05870-7592-713e-ba1a-98dcfa26c88a",
        "storage_key": "property/6767906449167749/01a05870-7592-713e-ba1a-98dcfa26c88a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Heights 3 Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=aLvf6HwhRVn"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0f479-260e-725e-ad88-52795e0ce1fb",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749"
    },
    {
      "lead_collector_id": "01a0f821-cd24-73ee-911d-3a183cbb549a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Heights at Happy Valley Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749"
    },
    {
      "lead_collector_id": "01a0f821-f4b0-70af-8fd6-683a8a86cfd0",
      "lead_source": "LANDING_PAGE",
      "name": "The Heights at Happy Valley Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-happy-valley-or",
      "search_query": "luxury apartments with pool Happy Valley OR",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Happy Valley, OR",
      "h2_subtitle": "Discover luxury living in Happy Valley, OR, featuring a stunning pool. Our luxury residences offer premier amenities for your comfort.",
      "page_copy": "Welcome to The Heights at Happy Valley, where luxury meets leisure in the heart of Happy Valley, OR. Our community is designed with you in mind, providing top-tier amenities that elevate everyday living. Dive into relaxation with access to our stunning pool and spa, ideal for unwinding after a long day or socializing on warm weekends. \n\nSituated in the serene Rock Creek neighborhood, The Heights offers more than just a place to live. Our property boasts a variety of unique features, including disc golf baskets, a pickleball court, and a children's playground, accommodating diverse lifestyles. With the added convenience of EV charging stations, our community ensures a modern, efficient living experience while you enjoy the lap of luxury.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Happy Valley, OR",
      "seo_description": "Explore The Heights at Happy Valley where luxury apartments with a pool await you in Happy Valley, OR. Experience upscale amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-clackamas-county",
      "search_query": "fitness center apartments in Clackamas County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Clackamas County",
      "h2_subtitle": "Find apartments with a fitness center in Clackamas County. Enjoy a healthy lifestyle at The Heights at Happy Valley.",
      "page_copy": "Experience the perfect blend of health and luxury at The Heights at Happy Valley, located in beautiful Clackamas County. Our community emphasizes wellness and convenience, offering residences equipped with outstanding fitness amenities and a welcoming atmosphere. While we do not have a traditional fitness center, you can enjoy our outdoor disc golf baskets and pickleball court, perfect for maintaining an active lifestyle in the fresh air.\n\nBeyond our fitness-focused features, The Heights provides a full-suite of exceptional amenities, from a refreshing pool and spa to a playground for families. Situated in the scenic Rock Creek neighborhood, our apartments are strategically positioned to offer the peace of Clackamas County with easy access to local attractions. Discover the unparalleled quality of life at The Heights today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Clackamas County",
      "seo_description": "Discover The Heights at Happy Valley, offering unique fitness-friendly amenities in Clackamas County. Perfect for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-bark-park-or-97015",
      "search_query": "pet friendly apartments with bark park OR 97015",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Bark Park in OR 97015",
      "h2_subtitle": "Explore pet friendly apartments in OR 97015. Enjoy the leash-free lifestyle at The Heights at Happy Valley.",
      "page_copy": "Welcome to The Heights at Happy Valley, your ideal pet-friendly community in OR 97015. While we offer plenty of outdoor spaces for you and your furry friends, we are excited to share that our community, nestled in the heart of the Rock Creek neighborhood, provides an accommodating and welcoming environment for pet lovers.\n\nOur amenities are tailored to enhance both human and pet experiences, promoting a playful and active lifestyle. Although we don’t have a specific bark park, you'll find plenty of nearby green spaces and trails perfect for walks and recreation. Experience the joy of living in a vibrant community with amenities such as a pool, spa, and electric vehicle charging stations, all while ensuring your pet feels right at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments with Bark Park in OR 97015",
      "seo_description": "Find pet-friendly living at The Heights in OR 97015. Enjoy a welcoming community with ample space for pets and humans alike.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "apartments-with-pickleball-court-rock-creek",
      "search_query": "apartments with pickleball court Rock Creek",
      "category": "Amenity",
      "h1_title": "Apartments with Pickleball Court in Rock Creek",
      "h2_subtitle": "Discover Rock Creek apartments featuring a pickleball court. Ideal for sports enthusiasts seeking a vibrant community.",
      "page_copy": "Step into The Heights at Happy Valley, where activity and relaxation blend seamlessly. Located in the picturesque Rock Creek neighborhood, our community boasts a state-of-the-art pickleball court, perfect for fans of this rapidly growing sport. Whether you're a seasoned player or just trying it out, you'll find it easy to engage with neighbors in friendly matches.\n\nAlongside our pickleball court, residents enjoy a suite of high-end amenities, including a pool and spa for unwinding, or a playground that keeps the younger ones entertained. Our community is also equipped with EV charging stations, highlighting our commitment to modern, sustainable living. Discover the vibrant lifestyle that awaits in Rock Creek, surrounded by scenic views and convenient access to local amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pickleball Court in Rock Creek",
      "seo_description": "Discover The Heights at Happy Valley in Rock Creek, offering a pickleball court and more. Enjoy active and relaxed living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "apartments-with-secure-package-room-happy-valley",
      "search_query": "apartments with secure package room Happy Valley",
      "category": "Amenity",
      "h1_title": "Secure Package Room Apartments in Happy Valley",
      "h2_subtitle": "Explore Happy Valley's apartments with secure package rooms. Enjoy peace of mind at The Heights at Happy Valley.",
      "page_copy": "Welcome to The Heights at Happy Valley, a modern haven featuring a secure package room designed for residents' convenience and peace of mind. Nestled in the charming city of Happy Valley, our community ensures your deliveries are safely stored until you retrieve them, adding an extra layer of security and ease to daily living.\n\nIn addition to the secure package room, The Heights offers a range of amenities that cater to a vibrant lifestyle. Enjoy our relaxing pool and spa, engage in friendly matches at the pickleball court, or let your kids have fun at the playground. Positioned in the Rock Creek area, our community also provides EV charging stations and beautiful green spaces, making it a perfect choice for those who value both convenience and recreation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Secure Package Room Apartments in Happy Valley",
      "seo_description": "Discover The Heights in Happy Valley with a secure package room. Enjoy modern amenities and peace of mind in our community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-happy-valley-or",
      "search_query": "one bedroom apartments in Happy Valley OR",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Happy Valley, OR",
      "h2_subtitle": "Discover spacious one bedroom apartments in Happy Valley. Enjoy a comfortable lifestyle at The Heights at Happy Valley.",
      "page_copy": "Welcome to The Heights at Happy Valley, where our one bedroom apartments provide the perfect blend of style and comfort. Located in the vibrant city of Happy Valley, OR, our thoughtfully designed spaces offer expansive living areas, modern finishes, and ample natural light.\n\nOur community is more than just a place to live; it's a lifestyle destination. Enjoy amenities such as a refreshing pool and spa, a pickleball court for social sports, and a playground for leisure activities. With our secure package room and EV charging stations, you'll find The Heights combines convenience with contemporary living. Come experience the inviting atmosphere of Happy Valley and make The Heights your new home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Happy Valley, OR",
      "seo_description": "Find your new home in Happy Valley, OR with our one bedroom apartments at The Heights, offering modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-clackamas-county",
      "search_query": "two bedroom apartments Clackamas County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Clackamas County",
      "h2_subtitle": "Explore spacious two bedroom apartments in Clackamas County. Enjoy modern living at The Heights at Happy Valley.",
      "page_copy": "Discover The Heights at Happy Valley, where spacious two bedroom apartments cater to all lifestyle needs in beautiful Clackamas County. Our community offers the perfect setting for families, roommates, or anyone seeking extra space, with thoughtfully designed layouts and contemporary interiors.\n\nLiving at The Heights means enjoying exceptional amenities along with your spacious apartment. Dive into relaxation at the pool and spa or play a game on our pickleball court. Kids can enjoy the on-site playground, while environmentally conscious residents benefit from our EV charging stations. Nestled in the Rock Creek area, The Heights combines modern convenience with the charm of Clackamas County, offering a welcoming and dynamic place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Clackamas County",
      "seo_description": "Discover spacious two bedroom apartments in Clackamas County at The Heights, offering modern amenities for a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-97015",
      "search_query": "three bedroom apartments near 97015",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 97015",
      "h2_subtitle": "Find spacious three bedroom apartments near the 97015 area. Discover luxurious living at The Heights at Happy Valley.",
      "page_copy": "Welcome to The Heights at Happy Valley, where our three bedroom apartments near the 97015 area offer ample space and luxurious comfort. Perfect for families or those needing extra room, these well-designed apartments provide generous living areas and modern features that make coming home a true pleasure.\n\nAt The Heights, not only do you enjoy beautiful interiors, but you also benefit from an array of amenities. Relax at our pool and spa, enjoy the playground with the kids, or challenge friends on the pickleball court. With a secure package room and EV charging stations, convenience is at your doorstep. Situated in Clackamas County, The Heights is where modern living meets scenic views near 97015.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 97015",
      "seo_description": "Explore spacious three bedroom apartments near the 97015 area at The Heights, featuring modern amenities for a luxury lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "apartments-near-clackamas-community-college-harmony-campus",
      "search_query": "apartments near clackamas community college harmony campus happy valley",
      "category": "School",
      "h1_title": "Apartments Near Clackamas Community College",
      "h2_subtitle": "Discover convenient apartments near Clackamas Community College Harmony Campus. Enjoy comfort at The Heights at Happy Valley.",
      "page_copy": "Experience convenience and comfort at The Heights at Happy Valley, ideally located near the Clackamas Community College Harmony Campus. Our apartments offer students and staff an easy commute, with the added benefits of a vibrant community and modern amenities.\n\nEnjoy a host of features, including a pool and spa for relaxation after classes, and a pickleball court to unwind with friends. Young residents will love the playground, and EV owners will appreciate the on-site charging stations. The Heights not only provides a convenient location but also offers a lively atmosphere in the heart of Happy Valley, making it an ideal choice for those connected to the Harmony Campus.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clackamas Community College",
      "seo_description": "Explore apartments near Clackamas Community College Harmony Campus at The Heights in Happy Valley. Enjoy modern living and top amenities close by.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "apartments-near-powell-butte-nature-park-happy-valley",
      "search_query": "apartments near powell butte nature park happy valley",
      "category": "Park",
      "h1_title": "Apartments Near Powell Butte Nature Park",
      "h2_subtitle": "Find serene apartments near Powell Butte Nature Park in Happy Valley. Discover comfort and nature at The Heights.",
      "page_copy": "Nestled in the picturesque setting of Happy Valley, The Heights offers apartments near Powell Butte Nature Park, perfect for nature lovers and outdoor enthusiasts. With easy access to scenic trails and breathtaking landscapes, residents can enjoy both convenience and tranquility.\n\nOur community features a diverse array of amenities including a relaxing pool and inviting spa, as well as exciting outdoor facilities like a pickleball court and playground. Embrace eco-friendly living with our EV charging stations, and enjoy the vibrant atmosphere of this Clackamas County community. Choose The Heights at Happy Valley for a harmonious blend of natural beauty and modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Powell Butte Nature Park",
      "seo_description": "Explore serene living at The Heights near Powell Butte Nature Park in Happy Valley, offering modern apartments and exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "happy-valley-park-nearby-apartments",
      "search_query": "happy valley park nearby apartments",
      "category": "Park",
      "h1_title": "Happy Valley Park Nearby Apartments",
      "h2_subtitle": "Explore apartments near Happy Valley Park for a perfect mix of nature and comfort. Discover life at The Heights.",
      "page_copy": "The Heights at Happy Valley offers an ideal living experience with apartments located near the scenic Happy Valley Park. Enjoy the convenience of being close to nature trails and expansive green spaces while living in a vibrant community that meets all your needs.\n\nRelish in modern amenities like our refreshing pool, luxurious spa, and family-friendly playground. Sports enthusiasts will appreciate the pickleball court, while eco-conscious residents can take advantage of our EV charging stations. With these fantastic amenities and the proximity to Happy Valley Park, The Heights provides a perfect setting for those seeking a blend of outdoor recreation and contemporary comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Happy Valley Park Nearby Apartments",
      "seo_description": "Live near Happy Valley Park at The Heights, offering apartments with modern amenities and a stunning natural backdrop.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "apartments-close-to-leach-botanical-garden-clackamas",
      "search_query": "apartments close to leach botanical garden clackamas county",
      "category": "Park",
      "h1_title": "Apartments Close to Leach Botanical Garden",
      "h2_subtitle": "Discover beautiful apartments close to Leach Botanical Garden in Clackamas County. Enjoy modern living at The Heights at Happy Valley.",
      "page_copy": "Located in the serene setting of Clackamas County, The Heights at Happy Valley provides charming apartments close to the enchanting Leach Botanical Garden. Immerse yourself in the tranquility of the garden's natural beauty while enjoying the comforts and amenities of modern apartment living.\n\nOur community features include a sparkling pool and soothing spa, a playground for the little ones, and a pickleball court for active residents. Eco-friendly amenities, such as EV charging stations, also support a sustainable lifestyle. Choose The Heights for convenient access to the lush landscapes of Leach Botanical Garden and a vibrant community atmosphere.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Leach Botanical Garden",
      "seo_description": "Explore The Heights at Happy Valley with modern apartments near Leach Botanical Garden in Clackamas County for a harmonious lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "rock-creek-neighborhood-apartments-near-carver-park",
      "search_query": "rock creek neighborhood apartments near carver park",
      "category": "Park",
      "h1_title": "Rock Creek Apartments Near Carver Park",
      "h2_subtitle": "Find delightful Rock Creek neighborhood apartments close to Carver Park. Experience vibrant community living at The Heights at Happy Valley.",
      "page_copy": "Welcome to The Heights at Happy Valley, where you can find premium apartments in the Rock Creek neighborhood, conveniently located near the serene Carver Park. Enjoy easy access to lush outdoor spaces while residing in a place that offers both modern amenities and a sense of community.\n\nOur amenities include a refreshing pool and spa, a playground for family fun, and a pickleball court for sports enthusiasts. For those embracing greener living, our EV charging stations are just the beginning. Discover a lifestyle that combines the beautiful outdoors with the comfort of contemporary living at The Heights at Happy Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rock Creek Apartments Near Carver Park",
      "seo_description": "Explore The Heights at Happy Valley offering Rock Creek neighborhood apartments with modern amenities near Carver Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "high-rocks-park-adjacent-apartments-97015",
      "search_query": "high rocks park adjacent apartments or 97015",
      "category": "Park",
      "h1_title": "Apartments Adjacent to High Rocks Park OR 97015",
      "h2_subtitle": "Experience life in apartments adjacent to High Rocks Park in the vibrant 97015 area. Discover The Heights at Happy Valley today.",
      "page_copy": "The Heights at Happy Valley is your gateway to a serene lifestyle, offering apartments positioned right next to the picturesque High Rocks Park in the 97015 area. Embrace a perfect balance of nature and modern living with stunning views and immediate access to park amenities.\n\nOur community boasts an array of conveniences, including a sparkling pool, relaxing spa, and a family-friendly playground. For the active lifestyle, enjoy a game of pickleball, and for eco-conscious residents, benefit from our EV charging stations. Choose The Heights and enjoy a living experience that beautifully complements the tranquil surroundings of High Rocks Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High Rocks Park Adjacent Apartments OR 97015",
      "seo_description": "Find ideal apartments next to High Rocks Park in OR 97015 at The Heights. Enjoy modern amenities in a scenic setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "apartments-near-clackamas-town-center-tc-happy-valley",
      "search_query": "apartments near Clackamas Town Center TC Happy Valley",
      "category": "Transit",
      "h1_title": "Apartments Near Clackamas Town Center Happy Valley",
      "h2_subtitle": "Explore comfortable living options near Clackamas Town Center at The Heights at Happy Valley. Enjoy convenience at its best.",
      "page_copy": "Discover The Heights at Happy Valley, where you can find stylish apartments just a short distance from the bustling Clackamas Town Center. In this vibrant area, enjoy retail therapy, dining, and entertainment options right at your doorstep.\n\nLiving at The Heights provides access to modern amenities like a refreshing pool, inviting spa, and a recreational pickleball court. Families will appreciate the on-site playground, and eco-conscious individuals can take advantage of our EV charging stations. Experience a blend of comfort and accessibility at The Heights, the ideal home near Clackamas Town Center in Happy Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clackamas Town Center Happy Valley",
      "seo_description": "Discover modern living at The Heights, offering apartments near Clackamas Town Center in Happy Valley with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "luxury-apartments-close-to-lents-town-center",
      "search_query": "luxury apartments close to Lents Town Center/SE Foster Rd OR",
      "category": "Transit",
      "h1_title": "Luxury Apartments Near Lents Town Center",
      "h2_subtitle": "Experience upscale living in luxury apartments near Lents Town Center/SE Foster Rd. Discover refined comfort at The Heights at Happy Valley.",
      "page_copy": "Indulge in elegant living at The Heights at Happy Valley, offering luxury apartments just a stone's throw away from Lents Town Center and SE Foster Rd in Oregon. Embrace top-of-the-line facilities and a prime location that provides convenience and sophistication.\n\nOur community is equipped with exceptional amenities, including a magnificent pool, revitalizing spa, and a playground for endless family fun. Sports enthusiasts can enjoy the pickleball court, while environmentally conscious residents will appreciate our EV charging stations. Select The Heights at Happy Valley for luxurious living near Lents Town Center where modern comforts meet convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near Lents Town Center OR",
      "seo_description": "Find luxury living at The Heights, offering high-end apartments near Lents Town Center/SE Foster Rd with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "affordable-living-near-se-flavel-street-clackamas-county",
      "search_query": "affordable living near SE Flavel Street Clackamas County",
      "category": "Transit",
      "h1_title": "Affordable Living Near SE Flavel Street",
      "h2_subtitle": "Discover affordable living options near SE Flavel Street, located in the heart of Clackamas County. Explore The Heights at Happy Valley.",
      "page_copy": "The Heights at Happy Valley offers an exceptional blend of affordability and comfort right near SE Flavel Street in Clackamas County. Our community provides a budget-friendly way to enjoy the serene lifestyle and modern amenities you desire.\n\nResidents benefit from a range of features, including a sparkling pool, relaxing hot spa, and a lively playground area. Enjoy leisure time at our pickleball court or utilize the EV charging options available for eco-friendly commuting. Experience cost-effective living enhanced by our community's proximity to SE Flavel Street, making The Heights a top choice in Happy Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Affordable Living Near SE Flavel Street",
      "seo_description": "Enjoy affordable living at The Heights near SE Flavel Street in Clackamas County with modern amenities and conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167749",
      "source": "generator",
      "page_item_url": "modern-apartments-by-se-fuller-rd-rock-creek",
      "search_query": "modern apartments by SE Fuller Rd Rock Creek",
      "category": "Transit",
      "h1_title": "Modern Apartments by SE Fuller Rd Rock Creek",
      "h2_subtitle": "Discover modern apartments located by SE Fuller Rd in the Rock Creek area. Experience the contemporary lifestyle at The Heights at Happy Valley.",
      "page_copy": "Located by SE Fuller Rd in the charming Rock Creek neighborhood, The Heights at Happy Valley offers modern apartments designed for today's lifestyle. Our community is perfect for those seeking contemporary living spaces combined with convenient access to local attractions.\n\nResidents enjoy a host of amenities such as a refreshingly modern pool area, an energizing spa, and a fun playground for children. Engage in active living with our exclusive pickleball court, or recharge your electric vehicle at our EV charging stations. Find your ideal modern home with all these features close to SE Fuller Rd in Rock Creek. Discover why The Heights is the preferred choice for modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments by SE Fuller Rd Rock Creek",
      "seo_description": "Explore modern living at The Heights, offering contemporary apartments by SE Fuller Rd in Rock Creek with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12935727379"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PVBMGPZX"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Avenue"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/zlporxq8pg4"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "b2823336-0db1-11f1-97d5-5787c06fbfac"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "3f7641f6-5a12-4392-8f3f-e4c85ae6a74c"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "5413056974"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "update"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "update"
    }
  ],
  "custom_repli_id": "12935727379",
  "custom_google_gtm_id": "GTM-PVBMGPZX",
  "custom_vibesites_theme": "Avenue",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/zlporxq8pg4",
  "custom_eliseai_building_token": "b2823336-0db1-11f1-97d5-5787c06fbfac",
  "custom_eliseai_organization_id": "3f7641f6-5a12-4392-8f3f-e4c85ae6a74c",
  "custom_ppc_tracking_phone_number": "5413056974",
  "custom_eliseai_tour_scheduler_url": "update",
  "custom_apartmentsync_javascript_id": "update"
};

export const generatedAt = '2026-10-01T16:13:25.203Z';
